// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../Poppins.scss";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../font/proxima-nova-regular/proximanova-regular-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../font/proxima-nova-regular/proximanova-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../font/proxima-nova-regular/proximanova-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../font/proxima-nova-regular/proximanova-regular-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../font/proxima-nova-regular/proximanova-regular-webfont.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../font/proxima-nova-light/proximanova-light-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../font/proxima-nova-light/proximanova-light-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../font/proxima-nova-light/proximanova-light-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../font/proxima-nova-light/proximanova-light-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../font/proxima-nova-light/proximanova-light-webfont.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../font/proxima-nova-semi-bold/ProximaNova-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../font/proxima-nova-bold/proximanova-bold-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../font/proxima-nova-bold/proximanova-bold-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../font/proxima-nova-bold/proximanova-bold-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../font/proxima-nova-bold/proximanova-bold-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../font/proxima-nova-bold/proximanova-bold-webfont.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#proxima_novaregular" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#proxima_novalight" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "#proxima_novabold" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  font-family: PoppinsRegular; /* 1 */
  -ms-text-size-adjust: 100%; /* 2 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

body {
  margin: 0;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
progress,
video {
  display: inline-block; /* 1 */
  vertical-align: baseline; /* 2 */
}

audio:not([controls]) {
  display: none;
  height: 0;
}

[hidden],
template {
  display: none;
}

a {
  background-color: transparent;
}

a:active,
a:hover {
  outline: 0;
}

abbr[title] {
  border-bottom: 1px dotted;
}

b,
strong {
  font-weight: bold;
}

dfn {
  font-style: italic;
}

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

mark {
  background: #ff0;
  color: #000;
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

img {
  border: 0;
}

svg:not(:root) {
  overflow: hidden;
}

figure {
  margin: 1em 40px;
}

hr {
  box-sizing: content-box;
  height: 0;
}

/**
 * Contain overflow in all browsers.
 */
pre {
  overflow: auto;
}

/**
 * Address odd \`em\`-unit font size rendering in all browsers.
 */
code,
kbd,
pre,
samp {
  font-family: PoppinsRegular;
  font-size: 1em;
}

button,
input,
optgroup,
select,
textarea {
  color: inherit; /* 1 */
  font: inherit; /* 2 */
  margin: 0; /* 3 */
}

/**
 * Address \`overflow\` set to \`hidden\` in IE 8/9/10/11.
 */
button {
  overflow: visible;
}

/**
 * Address inconsistent \`text-transform\` inheritance for \`button\` and \`select\`.
 * All other form control elements do not inherit \`text-transform\` values.
 * Correct \`button\` style inheritance in Firefox, IE 8/9/10/11, and Opera.
 * Correct \`select\` style inheritance in Firefox.
 */
button,
select {
  text-transform: none;
}

/**
 * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native \`audio\`
 *    and \`video\` controls.
 * 2. Correct inability to style clickable \`input\` types in iOS.
 * 3. Improve usability and consistency of cursor style between image-type
 *    \`input\` and others.
 */
button,
html input[type=button],
input[type=reset],
input[type=submit] {
  -webkit-appearance: button; /* 2 */
  cursor: pointer; /* 3 */
}

/**
 * Re-set default cursor for disabled elements.
 */
button[disabled],
html input[disabled] {
  cursor: default;
}

/**
 * Remove inner padding and border in Firefox 4+.
 */
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/**
 * Address Firefox 4+ setting \`line-height\` on \`input\` using \`!important\` in
 * the UA stylesheet.
 */
input {
  line-height: normal;
}

/**
 * It's recommended that you don't attempt to style these elements.
 * Firefox's implementation doesn't respect box-sizing, padding, or width.
 *
 * 1. Address box sizing set to \`content-box\` in IE 8/9/10.
 * 2. Remove excess padding in IE 8/9/10.
 */
input[type=checkbox],
input[type=radio] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Fix the cursor style for Chrome's increment/decrement buttons. For certain
 * \`font-size\` values of the \`input\`, it causes the cursor style of the
 * decrement button to change from \`default\` to \`text\`.
 */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Address \`appearance\` set to \`searchfield\` in Safari and Chrome.
 * 2. Address \`box-sizing\` set to \`border-box\` in Safari and Chrome
 *    (include \`-moz\` to future-proof).
 */
input[type=search] {
  -webkit-appearance: textfield; /* 1 */ /* 2 */
  box-sizing: content-box;
}

/**
 * Remove inner padding and search cancel button in Safari and Chrome on OS X.
 * Safari (but not Chrome) clips the cancel button when the search input has
 * padding (and \`textfield\` appearance).
 */
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * Define consistent border, margin, and padding.
 */
fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

/**
 * 1. Correct \`color\` not being inherited in IE 8/9/10/11.
 * 2. Remove padding so people aren't caught out if they zero out fieldsets.
 */
legend {
  border: 0; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Remove default vertical scrollbar in IE 8/9/10/11.
 */
textarea {
  overflow: auto;
}

/**
 * Don't inherit the \`font-weight\` (applied by a rule above).
 * NOTE: the default cannot safely be changed in Chrome and Safari on OS X.
 */
optgroup {
  font-weight: bold;
}

/* Tables
   ========================================================================== */
/**
 * Remove most spacing between table cells.
 */
table {
  border-collapse: collapse;
  border-spacing: 0;
}

td,
th {
  padding: 0;
}

@font-face {
  font-family: "proxima_novaregular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "proxima_novalight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "proxima_novasemibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("opentype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "proxima_novabold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/* Core ----------------------- */
/* Grays ---------------------- */
/* Neutrals ------------------- */
/* Primary -------------------- */
/* Blue ----------------------- */
/* Kobe ----------------------- */
/* Brown ---------------------- */
/* Red ------------------------ */
/* Yellow --------------------- */
/* Green ---------------------- */
html, body, .content h3, .content h4, .content h5, .content h6, .content div > h2, .content div > h1 {
  font-family: PoppinsRegular;
}

.sub-header-bar .sub-header-bar-content, .home .api-list, .home .instruction-container .instruction-body, .home .intro-container .intro-body, .navbar-container .navbar-content {
  padding-left: 2%;
  padding-right: 2%;
}

.content h3, .content h4, .content h5, .content h6, .content div > h2, .content div > h1 {
  font-style: normal;
}

.content pre, .content code {
  font-family: PoppinsRegular;
  font-size: 14px;
  line-height: 1.5;
}

.navbar-container {
  font-family: PoppinsRegular;
  font-weight: 650;
}

.resource-group {
  font-family: PoppinsRegular;
  font-weight: 500;
  font-style: normal;
  font-size: 14px;
}

.api-method {
  font-family: PoppinsRegular;
  font-weight: 500;
  font-size: 12px;
}

.home .card, .home {
  transition: all ease-in-out 0.25s;
}

.content code {
  word-break: break-all;
  hyphens: auto;
}

@font-face {
  font-family: "proxima_novaregular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "proxima_novalight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "proxima_novasemibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("opentype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "proxima_novabold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/* Core ----------------------- */
/* Grays ---------------------- */
/* Neutrals ------------------- */
/* Primary -------------------- */
/* Blue ----------------------- */
/* Kobe ----------------------- */
/* Brown ---------------------- */
/* Red ------------------------ */
/* Yellow --------------------- */
/* Green ---------------------- */
html, body, .content h3, .content h4, .content h5, .content h6, .content div > h2, .content div > h1 {
  font-family: PoppinsRegular;
}

.sub-header-bar .sub-header-bar-content, .home .api-list, .home .instruction-container .instruction-body, .home .intro-container .intro-body, .navbar-container .navbar-content {
  padding-left: 2%;
  padding-right: 2%;
}

.content h3, .content h4, .content h5, .content h6, .content div > h2, .content div > h1 {
  font-style: normal;
}

.content pre, .content code {
  font-family: PoppinsRegular;
  font-size: 14px;
  line-height: 1.5;
}

.navbar-container {
  font-family: PoppinsRegular;
  font-weight: 650;
}

.resource-group {
  font-family: PoppinsRegular;
  font-weight: 500;
  font-style: normal;
  font-size: 14px;
}

.api-method {
  font-family: PoppinsRegular;
  font-weight: 500;
  font-size: 12px;
}

.home .card, .home {
  transition: all ease-in-out 0.25s;
}

.content code {
  word-break: break-all;
  hyphens: auto;
}

.navbar-container {
  position: fixed !important;
  width: 100% !important;
  height: 78px;
  background: rgb(255, 255, 255);
  left: 0;
  top: 0;
  right: 0;
  z-index: 5000;
  color: #4035de !important;
}
.navbar-container .navbar-content {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
}
.navbar-container .navbar-content .navbar-heading {
  font-size: 12px;
  padding-top: 17px;
}
.navbar-container .navbar-content .navbar-heading img {
  width: 118px;
  height: 43px;
}
.navbar-container .navbar-content .navbar-list {
  padding-top: 10px;
}
.navbar-container .navbar-content .navbar-list .navbar-list-content {
  height: 40px;
}
.navbar-container .navbar-content .navbar-list .navbar-list-content a {
  text-decoration: none !important;
  color: #4035de !important;
}
.navbar-container .navbar-content .navbar-list .navbar-list-content .navbar-list-content-heading {
  margin: auto;
}

html {
  font-family: PoppinsRegular; /* 1 */
  -ms-text-size-adjust: 100%; /* 2 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

body {
  margin: 0;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
progress,
video {
  display: inline-block; /* 1 */
  vertical-align: baseline; /* 2 */
}

audio:not([controls]) {
  display: none;
  height: 0;
}

[hidden],
template {
  display: none;
}

a {
  background-color: transparent;
}

a:active,
a:hover {
  outline: 0;
}

abbr[title] {
  border-bottom: 1px dotted;
}

b,
strong {
  font-weight: bold;
}

dfn {
  font-style: italic;
}

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

mark {
  background: #ff0;
  color: #000;
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

img {
  border: 0;
}

svg:not(:root) {
  overflow: hidden;
}

figure {
  margin: 1em 40px;
}

hr {
  box-sizing: content-box;
  height: 0;
}

/**
 * Contain overflow in all browsers.
 */
pre {
  overflow: auto;
}

/**
 * Address odd \`em\`-unit font size rendering in all browsers.
 */
code,
kbd,
pre,
samp {
  font-family: PoppinsRegular;
  font-size: 1em;
}

button,
input,
optgroup,
select,
textarea {
  color: inherit; /* 1 */
  font: inherit; /* 2 */
  margin: 0; /* 3 */
}

/**
 * Address \`overflow\` set to \`hidden\` in IE 8/9/10/11.
 */
button {
  overflow: visible;
}

/**
 * Address inconsistent \`text-transform\` inheritance for \`button\` and \`select\`.
 * All other form control elements do not inherit \`text-transform\` values.
 * Correct \`button\` style inheritance in Firefox, IE 8/9/10/11, and Opera.
 * Correct \`select\` style inheritance in Firefox.
 */
button,
select {
  text-transform: none;
}

/**
 * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native \`audio\`
 *    and \`video\` controls.
 * 2. Correct inability to style clickable \`input\` types in iOS.
 * 3. Improve usability and consistency of cursor style between image-type
 *    \`input\` and others.
 */
button,
html input[type=button],
input[type=reset],
input[type=submit] {
  -webkit-appearance: button; /* 2 */
  cursor: pointer; /* 3 */
}

/**
 * Re-set default cursor for disabled elements.
 */
button[disabled],
html input[disabled] {
  cursor: default;
}

/**
 * Remove inner padding and border in Firefox 4+.
 */
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/**
 * Address Firefox 4+ setting \`line-height\` on \`input\` using \`!important\` in
 * the UA stylesheet.
 */
input {
  line-height: normal;
}

/**
 * It's recommended that you don't attempt to style these elements.
 * Firefox's implementation doesn't respect box-sizing, padding, or width.
 *
 * 1. Address box sizing set to \`content-box\` in IE 8/9/10.
 * 2. Remove excess padding in IE 8/9/10.
 */
input[type=checkbox],
input[type=radio] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Fix the cursor style for Chrome's increment/decrement buttons. For certain
 * \`font-size\` values of the \`input\`, it causes the cursor style of the
 * decrement button to change from \`default\` to \`text\`.
 */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Address \`appearance\` set to \`searchfield\` in Safari and Chrome.
 * 2. Address \`box-sizing\` set to \`border-box\` in Safari and Chrome
 *    (include \`-moz\` to future-proof).
 */
input[type=search] {
  -webkit-appearance: textfield; /* 1 */ /* 2 */
  box-sizing: content-box;
}

/**
 * Remove inner padding and search cancel button in Safari and Chrome on OS X.
 * Safari (but not Chrome) clips the cancel button when the search input has
 * padding (and \`textfield\` appearance).
 */
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * Define consistent border, margin, and padding.
 */
fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

/**
 * 1. Correct \`color\` not being inherited in IE 8/9/10/11.
 * 2. Remove padding so people aren't caught out if they zero out fieldsets.
 */
legend {
  border: 0; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Remove default vertical scrollbar in IE 8/9/10/11.
 */
textarea {
  overflow: auto;
}

/**
 * Don't inherit the \`font-weight\` (applied by a rule above).
 * NOTE: the default cannot safely be changed in Chrome and Safari on OS X.
 */
optgroup {
  font-weight: bold;
}

/* Tables
   ========================================================================== */
/**
 * Remove most spacing between table cells.
 */
table {
  border-collapse: collapse;
  border-spacing: 0;
}

td,
th {
  padding: 0;
}

@font-face {
  font-family: "proxima_novaregular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "proxima_novalight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "proxima_novasemibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("opentype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "proxima_novabold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/* Core ----------------------- */
/* Grays ---------------------- */
/* Neutrals ------------------- */
/* Primary -------------------- */
/* Blue ----------------------- */
/* Kobe ----------------------- */
/* Brown ---------------------- */
/* Red ------------------------ */
/* Yellow --------------------- */
/* Green ---------------------- */
html, body, .content h3, .content h4, .content h5, .content h6, .content div > h2, .content div > h1 {
  font-family: PoppinsRegular;
}

.sub-header-bar .sub-header-bar-content, .home .api-list, .home .instruction-container .instruction-body, .home .intro-container .intro-body, .navbar-container .navbar-content {
  padding-left: 2%;
  padding-right: 2%;
}

.content h3, .content h4, .content h5, .content h6, .content div > h2, .content div > h1 {
  font-style: normal;
}

.content pre, .content code {
  font-family: PoppinsRegular;
  font-size: 14px;
  line-height: 1.5;
}

.navbar-container {
  font-family: PoppinsRegular;
  font-weight: 650;
}

.resource-group {
  font-family: PoppinsRegular;
  font-weight: 500;
  font-style: normal;
  font-size: 14px;
}

.api-method {
  font-family: PoppinsRegular;
  font-weight: 500;
  font-size: 12px;
}

.home .card, .home {
  transition: all ease-in-out 0.25s;
}

.content code {
  word-break: break-all;
  hyphens: auto;
}

@font-face {
  font-family: "proxima_novaregular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
.home {
  margin-top: 78px !important;
}
.home .heading {
  font-size: 32px;
}
.home .postBody {
  height: 100px !important;
  color: black;
}
.home .intro-container {
  display: flex;
  min-height: 480px;
  background-color: #f7f7f7;
}
.home .intro-container .intro-body {
  display: flex;
  height: 100%;
  align-items: center;
  max-width: 1264px;
  margin: auto;
}
.home .intro-container .intro-body .intro-info {
  width: 50%;
}
.home .intro-container .intro-body .intro-info .intro-heading {
  width: 60%;
  font-size: 32px;
  line-height: 48px;
}
.home .intro-container .intro-body .intro-info .intro-heading .company-name {
  background: linear-gradient(89.88deg, #ff8045 2.69%, #7bd3cf 43.19%, #ab9cee 72%, #ffbd45 99.83%);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
}
.home .intro-container .intro-body .intro-info .intro-description {
  width: 60%;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  color: #000000;
}
.home .intro-container .intro-body .intro-info .intro-action {
  display: flex;
}
.home .intro-container .intro-body .intro-info .intro-action a {
  text-decoration: none;
}
.home .intro-container .intro-body .intro-info .intro-action .button {
  height: 42px;
  line-height: 22px;
  font-size: 14px;
  padding: 0px 24px;
}
.home .intro-container .intro-body .intro-info .intro-action .button:hover {
  background-color: #4035de;
  color: #ffffff;
}
.home .intro-container .intro-body .intro-image {
  width: 50%;
}
.home .intro-container .intro-body .intro-image img {
  height: 100%;
  width: 80%;
  float: right;
}
.home .instruction-container {
  display: flex;
  background-color: white;
  padding: 15px;
  min-height: 576px;
}
.home .instruction-container .instruction-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 1264px;
  margin: auto;
  height: 100%;
  text-align: center;
}
.home .instruction-container .instruction-body .api-list {
  padding-left: 0px;
  padding-right: 0px;
}
.home .instruction-container .instruction-body .card-body {
  text-align: center;
  padding: 0;
}
.home .api-container {
  padding: 100px 0px;
  text-align: center;
  background-color: #f7f7f7;
}
.home .api-container .card {
  overflow: auto;
  cursor: pointer;
}
.home .api-container .card .card-logo {
  fill: red;
}
.home .api-container .card:hover {
  background-color: #4035de;
}
.home .api-container .card:hover .card-heading {
  color: white !important;
}
.home .api-container .card:hover .card-description {
  color: white !important;
}
.home .api-container .card:hover .card-logo {
  filter: brightness(0) invert(1);
}
.home .api-list {
  max-width: 1264px;
  margin: 59px auto !important;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.home .api-list .card-heading {
  margin-top: 35px;
}
.home .api-list a {
  margin: auto;
  width: 25%;
  height: 232px;
  text-decoration: none;
}
.home .card {
  margin: 0;
  padding: 32px 32px 32px 32px;
  display: block;
  position: relative;
  text-align: left;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 11px;
  border: solid 1px transparent;
  height: 100%;
}
.home .card .card-body {
  word-wrap: break-word;
  width: auto;
  bottom: 0;
  margin: 0;
  text-align: left;
  height: 100%;
  overflow: auto;
}
.home .card .card-body .card-logo {
  fill: red;
}
.home .card .card-body .card-icon-body {
  margin: auto;
  margin-top: 11px;
  margin-bottom: 0px;
  border-radius: 50%;
  padding: 4px 6px;
  background-color: rgba(24, 172, 180, 0.2470588235);
}
.home .card .card-body .card-icon-body img {
  height: 22px;
  width: 22px;
}
.home .card .card-body .card-heading {
  color: #4a4a4a;
  width: 100%;
  margin: 0;
  font-size: 1.5rem;
  line-height: 36px;
  text-shadow: none;
  text-transform: capitalize;
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  max-width: 100%;
}
.home .card .card-body .card-description {
  color: #272727;
  line-height: 24px;
  font-size: 1rem;
  margin: 16px 0 44px 0;
  overflow: hidden;
}
.home .card .card-body::-webkit-scrollbar {
  display: none;
}
.home .card::-webkit-scrollbar {
  display: none;
}
.home .footer {
  height: 98px;
  max-width: 1264px;
  margin: auto;
}
.home .footer .footer-body {
  display: flex;
  align-items: center;
  height: 100%;
}
@media (max-width: 1024px) {
  .home .intro-heading {
    width: 100% !important;
  }
  .home .intro-description {
    width: 100% !important;
  }
}
@media (max-width: 998px) {
  .home .api-list a {
    width: 42% !important;
  }
}
@media (max-width: 768px) {
  .home .intro-body {
    flex-direction: column !important;
    gap: 30px !important;
  }
  .home .intro-body .intro-info {
    width: 100% !important;
  }
  .home .intro-body .intro-image {
    width: 100% !important;
  }
  .home .intro-body .intro-image img {
    float: unset !important;
  }
}
@media (max-width: 484px) {
  .home .api-list a {
    width: 84% !important;
  }
}

.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 31; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  margin-top: 9%;
  padding: 0px;
  border: 1px solid #888;
  width: 80%;
  max-width: 540px;
}

.modal-header {
  background-color: #4035de;
  /* margin-top: -14px; */
  height: 49px;
  padding: 1px 37px;
  color: white;
}

.modal-action {
  border-top: 1px solid gray;
  margin-top: 10px;
  display: flex;
  padding: 0px 15px;
  height: 48px;
  align-items: center;
  justify-content: flex-end;
}
.modal-action .loading-button {
  display: none;
}

.modal-body {
  padding: 0px 37px;
  height: 200px;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 14px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

@font-face {
  font-family: "proxima_novaregular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "proxima_novalight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "proxima_novasemibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("opentype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "proxima_novabold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
#codeblock-active {
  margin-left: -90px;
  padding: 5px 12px;
  background-color: rgba(0, 0, 0, 0.8745098039);
  border-radius: 4px;
  color: #fff;
}

#active-requestBody {
  color: grey;
}

html, body {
  color: #333;
  padding: 0;
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: white;
  -webkit-text-size-adjust: none; /* Never autoresize text */
  /* Track */
  /* Handle */
}
html ::-webkit-scrollbar, body ::-webkit-scrollbar {
  width: 2px;
  height: 2px;
}
html ::-webkit-scrollbar-track, body ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}
html ::-webkit-scrollbar-thumb, body ::-webkit-scrollbar-thumb {
  background: #8c95a8;
  border-radius: 10px;
}

.margin-12 {
  margin-left: 12px;
}

.subText {
  font-size: 16px;
}

.font-18 {
  font-size: 18px;
}

.navBottom {
  background-image: linear-gradient(270deg, #FF8045 6.35%, #F49666 9.54%, #E6B18F 15.9%, #DBC8B2 21.2%, #D2DACC 26.5%, #CCE6DF 32.86%, #C8EEEA 39.22%, #C7F0EE 45.58%, #CDC4F5 72.09%, #FFBD45 97.53%);
  height: 5px;
}

/* CSS for tryout button*/
.tryOut-btn {
  appearance: none;
  background-color: #4543d9;
  border: 2px solid #4543d9;
  border-radius: 30px;
  box-shadow: rgba(27, 31, 35, 0.1) 0 1px 0;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: PoppinsRegular;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  padding: 6px 16px;
  position: relative;
  text-align: center;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: middle;
  white-space: nowrap;
  margin-top: 0.2rem;
}
.tryOut-btn:hover {
  background-color: #7172da;
  border-color: #7172da;
}

.button--loading::after {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border: 4px solid transparent;
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: button-loading-spinner 1s ease infinite;
}

.execute-button {
  border-radius: 50px !important;
  background: #3c6d68 !important;
}
.execute-button:hover {
  background: #5ca59b !important;
}

.entity-name {
  display: inline !important;
  padding-left: 23px !important;
  font-weight: 600;
}

.green {
  color: #0d904f;
}

.tryout-code-line {
  width: 98%;
  overflow: visible;
  border: 2px solid transparent;
}

.tryout-code-line:focus-visible {
  outline: none;
  border: 2px solid #d1d5dc;
}

.header1-description {
  margin-right: 0px !important;
}

.tryout-modal {
  max-width: 1152px;
  width: calc(100% - 48px);
  height: 82%;
  margin-top: 33px;
}

.tryout-input-section {
  display: none;
}

.tryout-container {
  height: 100%;
  /* width , height*/
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.tryout-container .tryout-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f1f3f4;
}
.tryout-container .tryout-content .heading {
  font-size: 18px;
  color: #212121;
  font-weight: 600;
}
.tryout-container .tryout-content .tryout-header-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid #d7d7d7;
  flex: 0 0 48px;
  padding-top: 12px;
  padding-left: 20px;
}
.tryout-container .tryout-content .tryout-title {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 59rem;
}
.tryout-container .tryout-content .close-icon {
  cursor: pointer;
}
.tryout-container .tryout-content .tryout-body-container {
  display: flex;
  height: 100%;
  width: 100%;
  overflow: auto;
}
.tryout-container .tryout-content .tryout-body-container .tryout-parameter-container {
  width: 38%;
  padding: 16px;
  padding-left: 20px;
  border-right: 1px solid gray;
  overflow: auto;
}
.tryout-container .tryout-content .tryout-body-container .tryout-parameter-container .heading {
  font-size: 16px;
}
.tryout-container .tryout-content .tryout-body-container .tryout-parameter-container .parameters {
  margin-bottom: 12px;
}
.tryout-container .tryout-content .tryout-body-container .tryout-parameter-container .tryout-parameter-body .tryout-parameter-body-text {
  width: 90%;
  height: 200px;
}
.tryout-container .tryout-content .tryout-body-container .tryout-parameter-container .tryout-parameter-action button {
  width: 91px;
  height: 36px;
  color: #fff;
  border-radius: 4px;
  background-color: #039be5;
  outline: none;
  border: none;
  overflow: visible;
  transform: translate3d(0, 0, 0);
  transition: background 400ms cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.tryout-container .tryout-content .tryout-body-container .tryout-parameter-container .tryout-parameter-action button[disabled] {
  background-color: rgba(0, 0, 0, 0.12);
}
.tryout-container .tryout-content .tryout-body-container .tryout-parameter-container label {
  display: block;
  font-size: 16px;
}
.tryout-container .tryout-content .tryout-body-container .tryout-parameter-container input {
  display: block;
  border: 2px solid #d1d5dc;
  color: #353b46;
  outline: none;
  border-radius: 10px;
  width: 90%;
  padding: 7px 10px;
}
.tryout-container .tryout-content .tryout-body-container .tryout-parameter-container input:active {
  border: 2px solid #4d3ee0;
}
.tryout-container .tryout-content .tryout-body-container .tryout-parameter-container input:focus {
  border: 2px solid #4d3ee0;
}
.tryout-container .tryout-content .tryout-body-container .tryout-parameter-container span {
  cursor: pointer;
}
.tryout-container .tryout-content .tryout-body-container .tryout-code-samples-container {
  width: 60%;
  padding: 20px 10px;
  overflow: auto;
  background-color: #fff;
  position: relative;
}
.tryout-container .tryout-content .tryout-body-container .tryout-code-samples-container .curl-code-container {
  overflow: auto;
  height: 40%;
}
.tryout-container .tryout-content .tryout-body-container .tryout-code-samples-container .tryout-code-samples-response {
  width: 100%;
  height: 60%;
}
.tryout-container .tryout-content .tryout-body-container .tryout-code-samples-container .tryout-code-samples-response .response-textarea {
  width: 100%;
  height: 100%;
}
.tryout-container ::-webkit-scrollbar {
  width: 10px;
  height: 7px;
}
.tryout-container ::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.tryout-container ::-webkit-scrollbar-thumb {
  background: #888;
}
.tryout-container ::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.app-loader-cntr {
  position: fixed;
  right: 0;
  top: 50%;
  left: 50%;
  bottom: 0;
  z-index: 9999;
}
.app-loader-cntr img {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 40px;
}

.margin-10 {
  margin: 10px 0px;
}

.bold {
  font-weight: bold;
}

.extra-padding {
  padding-top: 120px !important;
}

.h0 {
  display: none;
}

.side-menu-layout {
  width: 20% !important;
}

.side-wrapper::-webkit-scrollbar {
  width: 4px;
}

.side-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.side-wrapper::-webkit-scrollbar-thumb {
  background-color: #4035de;
  opacity: 0.4;
  border-radius: 2px;
}

#toc > ul > li > a > span {
  float: right;
  background-color: #2484FF;
  border-radius: 40px;
  width: 20px;
}

.side-wrapper {
  transition: left 0.3s ease-in-out;
  overflow-y: auto;
  overflow-x: hidden;
  position: fixed;
  z-index: 30;
  top: 80px;
  left: 0;
  bottom: 0;
  width: 279px;
  background-color: #F8F8F8;
  font-size: 14px;
  border-right: 1px solid #ccc;
  box-shadow: 1px 0px 0px rgba(0, 0, 0, 0.08);
}
.side-wrapper .api-method {
  margin-left: 6px;
}
.side-wrapper .lang-selector {
  display: none;
}
.side-wrapper .lang-selector a {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.side-wrapper .side-wrapper-body {
  padding: 0 20px 32px 20px;
}
.side-wrapper .search-container {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}
.side-wrapper .search-bar {
  display: flex;
  justify-content: space-evenly;
}
.side-wrapper .search {
  position: relative;
  margin-bottom: 32px;
}
.side-wrapper .search input {
  background: white;
  /* border-width: 0 0 1px 0; */
  border: 2px solid #d1d5dc;
  padding-left: 47px;
  width: 80%;
  border-radius: 10px;
  /* -webkit-box-sizing: border-box; */
  /* box-sizing: border-box; */
  margin: 0px;
  /* width: auto; */
  /* outline: none; */
  color: #353b46;
  height: 40px;
  font-size: 16px;
  outline: none;
  /* border-radius: 0;/* ios has a default border radius */
}
.side-wrapper .search input:active {
  border: 2px solid #4d3ee0 !important;
}
.side-wrapper .search:before {
  position: absolute;
  top: 17px;
  left: 15px;
  color: #222222;
}
.side-wrapper .search .search-icon {
  position: absolute;
  top: 11px;
  left: 15px;
  width: 19px;
  height: 19px;
  z-index: 1;
}
.side-wrapper .search .search-icon img {
  height: 100%;
  width: 100%;
}
.side-wrapper #input-search:focus-visible {
  outline: none;
  border: 2px solid #4d3ee0 !important;
}
.side-wrapper .search-results {
  margin-top: 1.2rem;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  transition-property: height, margin;
  transition-duration: 180ms;
  transition-timing-function: ease-in-out;
  background: white;
}
.side-wrapper .search-results.visible {
  height: 30%;
  margin-bottom: 1em;
}
.side-wrapper .search-results li {
  margin: 1em 15px;
  line-height: 1;
}
.side-wrapper .search-results a {
  color: #222222;
  text-decoration: none;
  cursor: pointer;
}
.side-wrapper .search-results a:hover {
  text-decoration: underline;
}
.side-wrapper ul, .side-wrapper li {
  list-style: none;
  margin: 0;
  padding: 0;
  line-height: 28px;
}
.side-wrapper li {
  cursor: pointer;
  color: #222222;
  transition-property: background;
  transition-timing-function: linear;
  transition-duration: 200ms;
}
.side-wrapper .toc-link.active {
  cursor: pointer;
  color: #4035de;
  background-color: rgba(64, 53, 222, 0.09);
}
.side-wrapper .toc-h1 {
  font-size: 16px;
  cursor: pointer;
}
.side-wrapper .toc-list-h2 {
  font-weight: 400;
}
.side-wrapper .toc-list-h3 {
  display: none;
  font-weight: 400;
}
.side-wrapper .toc-h2 {
  padding-left: 35px;
  font-size: 16px;
}
.side-wrapper .toc-h3 {
  padding-left: 40px;
  font-size: 16px;
}
.side-wrapper .toc-h4 {
  padding-left: 50px;
  font-size: 16px;
}

.toc-link, .toc-footer li {
  word-break: break-all;
  padding: 0 15px 0 15px;
  display: flex;
  white-space: pre-wrap;
  text-decoration: none;
  overflow-wrap: break-word;
  color: #222222;
  transition-property: background;
  transition-timing-function: linear;
  transition-duration: 130ms;
}

#nav-button {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10001;
  color: #000;
  text-decoration: none;
  font-weight: bold;
  opacity: 0.7;
  line-height: 16px;
  margin-top: 23px;
  margin-left: 10px;
  transition: left 0.3s ease-in-out;
}
#nav-button span {
  display: block;
  background-color: rgba(255, 255, 255, 0.7);
  transform-origin: 0 0;
  transform: rotate(-90deg) translate(-100%, 0);
  border-radius: 0 0 0 5px;
}
#nav-button img {
  height: 25px;
  width: 25px;
  vertical-align: bottom;
}
#nav-button:hover {
  opacity: 1;
}
#nav-button.open {
  left: 279px;
}

.upload-button {
  display: flex;
  line-height: 24px;
  cursor: pointer;
}
.upload-button img {
  width: 13px;
  height: 13px;
  margin-top: 4px;
  margin-right: 6px;
}
.upload-button .button {
  color: white;
  background-color: transparent;
  margin: 0px 0px 0px -4px;
}

.page-wrapper {
  margin-left: 20%;
  margin-right: 3.2%;
  position: relative;
  z-index: 10;
  background-color: white;
  min-height: 100%;
  padding-bottom: 1px;
  top: 58px;
  max-height: calc(100vh - 134px);
}
.page-wrapper .dark-box {
  width: 40%;
  right: 7px;
  top: -9px;
  bottom: 0;
  float: right;
}
.page-wrapper .lang-selector {
  z-index: 50;
}

.page-wrapper::-webkit-scrollbar {
  width: 7px !important;
  height: 2px;
}

.lang-selector {
  display: flex;
  align-items: center;
  background-color: #42484C;
  width: 100%;
  height: 100%;
  font-weight: 400;
  overflow-x: auto;
}
.lang-selector a {
  display: inline;
  color: #FFFFFF;
  text-decoration: none;
  padding: 0 10px;
  line-height: 26px;
  outline: 0;
}
.lang-selector a:active, .lang-selector a:focus {
  border-bottom: 2px solid #4035de;
  color: #fff;
}
.lang-selector a.active {
  border-bottom: 2px solid #8c95a8;
  color: #fff;
}
.lang-selector:after {
  content: "";
  clear: both;
  display: block;
}

.content > .main-section {
  border-top: 1px solid white;
  padding-top: 10px;
}

.content > .main-section ~ .main-section {
  border-top: 1px solid #ccc;
}

.content {
  -webkit-transform: translateZ(0);
  position: relative;
  z-index: 30;
}
.content:after {
  content: "";
  display: block;
  clear: both;
}
.content .parameter-layout {
  margin-top: 2.5rem;
  margin-bottom: 0.8rem;
}
.content .parameter-heading {
  display: inline;
}
.content div > p, .content div > h1, .content div > h2, .content div > h3, .content div > h4, .content div > h5, .content div > h6 .content div > ul, .content div > ol, .content div > aside, .content div > dl {
  margin-right: 40%;
  box-sizing: border-box;
  display: block;
  word-spacing: 1px;
}
.content > ul, .content > ol, .content > div {
  padding-left: 5%;
}
.content > h1, .content > h2, .content > div {
  clear: both;
}
.content div > h1 {
  padding-bottom: 0.5em;
  margin-bottom: 21px;
  font-weight: 500;
  font-size: 26px;
  line-height: 32px;
  border-top: 1px solid #ccc;
}
.content .content:nth-child(1) {
  border: 0px;
}
.content h1:first-child, .content div:first-child + h1 {
  border-top-width: 0;
}
.content div > h2 {
  word-break: break-word;
  margin-bottom: 0;
  padding-bottom: 1.2em;
  line-height: 26px;
  font-weight: 500;
  font-size: 20px;
  line-height: 26px;
  padding-top: 1rem;
}
.content div > h2:focus {
  padding-top: 138px;
}
.content h1 + h2, .content h1 + div + h2 {
  margin-top: -21px;
  border-top: none;
}
.content h3, .content h4, .content h5, .content h6 {
  font-weight: 500;
  font-size: 22px;
  line-height: 20px;
  margin-top: 2.5em;
  margin-bottom: 0.8em;
  color: #313131;
}
.content h4, .content h5, .content h6 {
  font-size: 12px;
}
.content hr {
  margin: 2em 0;
  border-top: 2px solid #2E3336;
  border-bottom: 2px solid white;
}
.content div > table {
  display: table;
  table-layout: fixed;
  overflow: auto;
  width: 50%;
  margin-bottom: 1em;
}
.content div > table th, .content div > table td {
  text-align: left;
  vertical-align: top;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #000000;
}
.content div > table th code, .content div > table td code {
  white-space: nowrap;
}
.content div > table th {
  padding: 5px 10px;
  border-bottom: 1px solid #d1d5dc;
  vertical-align: bottom;
  background-color: #F7FAFB;
}
.content div > table td {
  padding: 10px;
  max-width: 325px;
}
.content div > table tr {
  border-bottom: 1px solid #ccc;
  height: 48px;
}
.content div > table tr:nth-child(odd) > td {
  background-color: white;
}
.content div > table tr:nth-child(even) > td {
  background-color: white;
}
.content table.properties {
  table-layout: auto;
}
.content table.properties th:first-child {
  width: auto;
}
.content table.properties th:last-child {
  width: 45%;
}
.content dt {
  font-weight: bold;
}
.content dd {
  margin-left: 15px;
}
.content li, .content dt, .content dd {
  line-height: 1.6;
  margin-top: 0;
}
.content p {
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
}
.content p code {
  font-size: 16px;
  line-height: 22px;
}
.content img {
  max-width: 100%;
}
.content code {
  padding: 3px;
  border-radius: 3px;
}
.content pre > code {
  background-color: transparent;
  padding: 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  overflow: auto;
}
.content aside {
  padding-top: 1em;
  padding-bottom: 1em;
  margin-top: 1.5em;
  margin-bottom: 1.5em;
  background: #8fbcd4;
  line-height: 1.6;
}
.content aside.warning {
  background-color: #c97a7e;
}
.content aside.success {
  background-color: #6ac174;
}
.content .search-highlight {
  padding: 2px;
  margin: -3px;
  border-radius: 4px;
  border: 1px solid #F7E633;
  background: linear-gradient(to top left, #F7E633 0%, #F1D32F 100%);
}

.codeBlock {
  color: #fff;
}

.content > div.highlight {
  clear: none;
}
.content pre, .content blockquote {
  background-color: #35393C;
  margin: 0;
  width: 40%;
  float: right;
  clear: right;
  box-sizing: border-box;
}
.content pre > p, .content blockquote > p {
  margin: 0;
}
.content pre a, .content blockquote a {
  color: #fff;
  text-decoration: none;
  border-bottom: dashed 1px #ccc;
}
.content pre {
  padding-top: 2em;
  padding-bottom: 2em;
  padding: 2em 28px;
  margin-bottom: 16px;
  display: flex;
  position: relative;
  flex-direction: column;
}
.content blockquote > p {
  background-color: #42484C;
  padding: 13px 2em;
  color: #eee;
}
.content .method-example-part {
  max-height: 300px;
  overflow-y: auto;
  float: right;
  width: 37%;
  clear: right;
}
.content .method-example-part pre, .content .method-example-part blockquote {
  width: 100% !important;
}
.content .method-example-part .dark-box {
  width: 100% !important;
  height: 46px;
}
.content .example-request {
  margin-bottom: 16px;
  border-radius: 8px;
}
.content .example-request pre {
  margin-bottom: 0 !important;
  border-radius: 0 0 10px 10px;
}
.content .example-request-body {
  margin-bottom: 16px;
  border-radius: 8px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.0705882353);
}
.content .example-request-body pre {
  margin-bottom: 0 !important;
}
.content .response-header {
  letter-spacing: 0.01em;
  background: #E4E8ED;
  margin-top: 19px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.content .response-header p {
  padding: 13px 2em;
  margin: 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #3A3A3A;
}
.content .example-request-response {
  max-height: 254px !important;
  margin-bottom: 16px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.0705882353);
}
.content .example-request-response .highlight .nl, .content .example-request-response .p {
  color: #697386;
}
.content .example-request-response .highlight .s2 {
  color: #09825d;
}
.content .example-request-response blockquote p {
  background: #F8FAFC !important;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  color: #2E2E2E;
  border-bottom: 1px solid #DFE7EC;
}
.content .example-request-response pre {
  background: #f7fafc !important;
  margin-bottom: 0 !important;
}

.active {
  color: #4035de;
}

.link-button {
  display: inline-block;
  padding: 13px 21px;
  color: #fff;
  background-color: #4543d9;
  border: 2px solid #4543d9;
  border-radius: 100px;
  transition-duration: 0.15s;
  font-weight: 700;
  text-decoration: none;
}

.link-button:hover {
  background-color: #7172da;
  border-color: #7172da;
}

@media screen and (max-width: 1399px) {
  .page-wrapper {
    margin-left: 20%;
    margin-right: 5%;
  }
}
@media (max-width: 1024px) {
  .side-wrapper {
    left: -279px;
  }
  .side-wrapper.open {
    left: 0;
  }
  .page-wrapper {
    margin-left: 0;
  }
  #nav-button {
    display: block;
  }
  .toc-link {
    padding-top: 0.3em;
    padding-bottom: 0.3em;
  }
  .method-example-part {
    width: 100% !important;
    margin-left: 0% !important;
  }
  div > table {
    width: 100% !important;
  }
}
@media (max-width: 745px) {
  .dark-box {
    display: none;
  }
  .content div > p, .content div > h1, .content div > h2, .content div > h3, .content div > h4, .content div > h5, .content div > h6 .content div > ul, .content div > ol, .content div > aside, .content div > dl {
    margin-right: 0;
  }
  .side-wrapper .lang-selector {
    display: block;
  }
  .page-wrapper .lang-selector {
    display: none;
  }
  .method-example-part {
    width: 100% !important;
    margin-left: 0% !important;
  }
  .content pre, .content blockquote {
    width: auto;
    float: none;
  }
  .content div > pre + p, .content div > blockquote + p, .content div > pre + h1, .content div > blockquote + h1, .content div > pre + h2, .content div > blockquote + h2, .content div > pre + h3, .content div > blockquote + h3, .content div > pre + h4, .content div > blockquote + h4, .content div > pre + h5, .content div > blockquote + h5, .content div > h6 .content div > pre + ul, .content div > h6 .content div > blockquote + ul, .content div > pre + ol, .content div > blockquote + ol, .content div > pre + aside, .content div > blockquote + aside, .content div > pre + dl, .content div > blockquote + dl {
    margin-top: 28px;
  }
  div > table {
    width: 100% !important;
  }
}
.highlight .c, .highlight .cm, .highlight .c1, .highlight .cs {
  color: #909090;
}

.highlight .s1 {
  color: #85d996;
}

.highlight .nt, .highlight .nl {
  color: aliceblue;
}

.copy-clipboard, .curl-copy-clipboard {
  fill: #9DAAB6;
  position: absolute;
  cursor: pointer;
  opacity: 0.4;
  height: 18px;
  right: 29px;
  width: 18px;
}

.copy-clipboard, .curl-copy-clipboard:hover {
  opacity: 0.8;
}

.container {
  margin: 0px;
}

.content {
  margin: 0px;
}

.button {
  background-color: rgb(255, 255, 255);
  border: 1px solid #4035de;
  border-radius: 30px;
  font-size: 16px;
  color: #4035de;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 4px;
}

.resource-group {
  padding: 2px 3px !important;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 5px !important;
}

.resource-group .heading a {
  margin: 0 0 5px 0;
  border: 0;
  border-radius: 0;
  padding-right: 0px;
  cursor: pointer;
}

.heading {
  position: relative;
}
.heading img {
  width: 18px;
  height: 18px;
  top: 3px;
  position: absolute;
}

.show {
  display: block !important;
}

.sub-header-bar {
  background-color: #e8eaee;
  border: 1px solid #e8eaee;
  height: 40px;
  color: #464f5e;
  border-radius: 10px;
  margin-top: 10px;
}
.sub-header-bar .sub-header-bar-content {
  height: 100%;
  display: flex;
  max-width: 1264px;
}
.sub-header-bar .sub-header-bar-menu {
  position: relative;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: space-between;
}
.sub-header-bar .sub-header-bar-menu .version-tag {
  position: relative;
}
.sub-header-bar .sub-header-bar-menu .version-tag span {
  float: right;
  padding-left: 7px;
  padding-top: 3px;
}
.sub-header-bar .sub-header-bar-menu .version-tag:hover {
  cursor: pointer;
}
.sub-header-bar .sub-header-bar-menu .version-active {
  display: block;
}
.sub-header-bar .sub-header-bar-menu body {
  background-color: #FAC945;
  justify-content: center;
  display: flex;
  height: 100vh;
  margin-top: 150px;
  font-size: 17px;
  color: #4B4D54;
  overflow: hidden;
  font-family: PoppinsRegular;
}
.sub-header-bar .sub-header-bar-menu .dropdown {
  width: 300px;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  background-color: white;
}
.sub-header-bar .sub-header-bar-menu .dropdown-header {
  padding: 15px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sub-header-bar .sub-header-bar-menu .dropdown-body {
  padding: 5px;
  border-top: 1px solid #E5E8EC;
  display: none;
}
.sub-header-bar .sub-header-bar-menu .dropdown-body.open {
  display: block;
}
.sub-header-bar .sub-header-bar-menu .dropdown-item {
  padding: 10px;
}
.sub-header-bar .sub-header-bar-menu .dropdown-item:hover {
  cursor: pointer;
}
.sub-header-bar .sub-header-bar-menu .dropdown-item-dot {
  opacity: 0;
  color: #91A5BE;
  transition: all 0.2s ease-in-out;
}
.sub-header-bar .sub-header-bar-menu .dropdown-item-dot.selected {
  opacity: 1;
}
.sub-header-bar .sub-header-bar-menu .icon {
  font-size: 13px;
  color: #91A5BE;
  transform: rotate(0deg);
  transition: all 0.2s ease-in-out;
}
.sub-header-bar .sub-header-bar-menu .icon.open {
  transform: rotate(90deg);
}
.sub-header-bar .sub-header-bar-menu .version-tag-option {
  display: block;
  position: absolute;
  min-width: 144px;
  top: 36px;
  display: none;
  padding: 13px 14px;
  background: inherit;
  background-color: rgb(255, 255, 255);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(242, 242, 242);
  border-radius: 5px;
  z-index: 99;
  color: #43515C;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);
}
.sub-header-bar .sub-header-bar-menu .version-tag-option a {
  display: block;
  position: relative;
  cursor: pointer;
  text-decoration: none;
}
.sub-header-bar .sub-header-bar-menu .down-arrow {
  right: 9px;
  top: 0;
  position: absolute;
}

.arrow {
  padding-right: 5px;
}

.api-method {
  border-radius: 3px;
  padding: 0px 7px;
  color: white;
  display: inline-flex;
  justify-content: center;
  height: 18px;
  line-height: 18px;
  text-transform: uppercase;
  margin-bottom: auto;
  margin-top: auto;
  margin-left: 5px;
}

.get {
  background-color: #0e9b71;
}

.options {
  background-color: #0272d9;
}

.post {
  background-color: #0272d9;
}

.put {
  background-color: #674ead;
}

.patch {
  background-color: #df7d03;
}

.delete {
  background-color: red;
}

.sidebar-link-text {
  width: 73%;
  height: 30px;
  overflow: hidden;
}

.sidebar-item-link {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}

#custom-tooltip {
  display: none;
  margin-left: -100px;
  padding: 5px 12px;
  background-color: rgba(0, 0, 0, 0.8745098039);
  border-radius: 4px;
  color: #fff;
}

@keyframes button-loading-spinner {
  from {
    transform: rotate(0turn);
  }
  to {
    transform: rotate(1turn);
  }
}`, "",{"version":3,"sources":["webpack://./src/stylesheets/_normalize.scss","webpack://./src/stylesheets/screen.css.scss","webpack://./src/stylesheets/_font.scss","webpack://./src/stylesheets/_variables.scss","webpack://./src/stylesheets/_navbar.scss","webpack://./src/stylesheets/_icon-font.scss","webpack://./src/stylesheets/_home.scss","webpack://./src/stylesheets/_modal.scss"],"names":[],"mappings":"AAEA;EACI,2BAAA,EAAA,MAAA;EACA,0BAAA,EAAA,MAAA;EACA,8BAAA,EAAA,MAAA;ACEJ;;ADEA;EACI,SAAA;ACCJ;;ADGA;;;;;;;;;;;;;EAaI,cAAA;ACAJ;;ADKA;;;;EAII,qBAAA,EAAA,MAAA;EACA,wBAAA,EAAA,MAAA;ACFJ;;ADMA;EACI,aAAA;EACA,SAAA;ACHJ;;ADQA;;EAEI,aAAA;ACLJ;;ADSA;EACI,6BAAA;ACNJ;;ADWA;;EAEI,UAAA;ACRJ;;ADaA;EACI,yBAAA;ACVJ;;ADcA;;EAEI,iBAAA;ACXJ;;ADgBA;EACI,kBAAA;ACbJ;;ADkBA;EACI,cAAA;EACA,gBAAA;ACfJ;;ADmBA;EACI,gBAAA;EACA,WAAA;AChBJ;;ADqBA;EACI,cAAA;AClBJ;;ADuBA;;EAEI,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;ACpBJ;;ADuBA;EACI,WAAA;ACpBJ;;ADuBA;EACI,eAAA;ACpBJ;;AD4BA;EACI,SAAA;ACzBJ;;AD+BA;EACI,gBAAA;AC5BJ;;ADmCA;EACI,gBAAA;AChCJ;;ADsCA;EAEI,uBAAA;EACA,SAAA;ACnCJ;;ADsCA;;EAAA;AAIA;EACI,cAAA;ACpCJ;;ADuCA;;EAAA;AAIA;;;;EAII,2BAAA;EACA,cAAA;ACrCJ;;ADyCA;;;;;EAKI,cAAA,EAAA,MAAA;EACA,aAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;ACtCJ;;ADyCA;;EAAA;AAIA;EACI,iBAAA;ACvCJ;;AD0CA;;;;;EAAA;AAOA;;EAEI,oBAAA;ACxCJ;;AD2CA;;;;;;EAAA;AAQA;;;;EAII,0BAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;ACzCJ;;AD4CA;;EAAA;AAIA;;EAEI,eAAA;AC1CJ;;AD6CA;;EAAA;AAIA;;EAEI,SAAA;EACA,UAAA;AC3CJ;;AD8CA;;;EAAA;AAKA;EACI,mBAAA;AC5CJ;;AD+CA;;;;;;EAAA;AAQA;;EAEI,sBAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;AC7CJ;;ADgDA;;;;EAAA;AAMA;;EAEI,YAAA;AC9CJ;;ADiDA;;;;EAAA;AAMA;EACI,6BAAA,EAAA,MAAA,EAEA,MAAA;EACA,uBAAA;AC/CJ;;ADkDA;;;;EAAA;AAMA;;EAEI,wBAAA;AChDJ;;ADmDA;;EAAA;AAIA;EACI,yBAAA;EACA,aAAA;EACA,8BAAA;ACjDJ;;ADoDA;;;EAAA;AAKA;EACI,SAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;AClDJ;;ADqDA;;EAAA;AAIA;EACI,cAAA;ACnDJ;;ADsDA;;;EAAA;AAKA;EACI,iBAAA;ACpDJ;;ADuDA;+EAAA;AAGA;;EAAA;AAIA;EACI,yBAAA;EACA,iBAAA;ACtDJ;;ADyDA;;EAEI,UAAA;ACtDJ;;ACtSA;EACI,kCAAA;EACA,4CAAA;EACA,4SAAA;EAUA,mBAAA;EACA,kBAAA;ADgSJ;AC7RE;EACE,gCAAA;EACA,4CAAA;EACA,8SAAA;EAUA,mBAAA;EACA,kBAAA;ADsRJ;AClRE;EACE,mCAAA;EACA,gEAAA;EAEA,mBAAA;EAEA,kBAAA;ADkRJ;AC/QE;EACE,+BAAA;EACA,6CAAA;EACA,iTAAA;EAUA,mBAAA;EACA,kBAAA;ADwQJ;AExRA,iCAAA;AAIA,iCAAA;AASA,iCAAA;AAWA,iCAAA;AAQA,iCAAA;AAUA,iCAAA;AASA,iCAAA;AAQA,iCAAA;AAQA,iCAAA;AAOA,iCAAA;AAoDA;EACE,2BAAA;AFsKF;;AElKA;EACE,gBAlDc;EAmDd,iBAnDc;AFwNhB;;AEnKA;EAEE,kBAAA;AFqKF;;AElKA;EACE,2BAAA;EACA,eAAA;EACA,gBAAA;AFqKF;;AElKA;EACE,2BAAA;EACA,gBAAA;AFqKF;;AEnKA;EACE,2BAAA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;AFsKJ;;AElKA;EACE,2BAAA;EACA,gBAAA;EACA,eA5CyB;AFiN3B;;AEtJA;EAKI,iCAAA;AFyJJ;;AEvJA;EACI,qBAAA;EACA,aAAA;AF0JJ;;AC7XA;EACI,kCAAA;EACA,4CAAA;EACA,4SAAA;EAUA,mBAAA;EACA,kBAAA;ADuXJ;ACpXE;EACE,gCAAA;EACA,4CAAA;EACA,8SAAA;EAUA,mBAAA;EACA,kBAAA;AD6WJ;ACzWE;EACE,mCAAA;EACA,gEAAA;EAEA,mBAAA;EAEA,kBAAA;ADyWJ;ACtWE;EACE,+BAAA;EACA,6CAAA;EACA,iTAAA;EAUA,mBAAA;EACA,kBAAA;AD+VJ;AE/WA,iCAAA;AAIA,iCAAA;AASA,iCAAA;AAWA,iCAAA;AAQA,iCAAA;AAUA,iCAAA;AASA,iCAAA;AAQA,iCAAA;AAQA,iCAAA;AAOA,iCAAA;AAoDA;EACE,2BAAA;AF6PF;;AEzPA;EACE,gBAlDc;EAmDd,iBAnDc;AF+ShB;;AE1PA;EAEE,kBAAA;AF4PF;;AEzPA;EACE,2BAAA;EACA,eAAA;EACA,gBAAA;AF4PF;;AEzPA;EACE,2BAAA;EACA,gBAAA;AF4PF;;AE1PA;EACE,2BAAA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;AF6PJ;;AEzPA;EACE,2BAAA;EACA,gBAAA;EACA,eA5CyB;AFwS3B;;AE7OA;EAKI,iCAAA;AFgPJ;;AE9OA;EACI,qBAAA;EACA,aAAA;AFiPJ;;AGldA;EAEE,0BAAA;EACD,sBAAA;EACA,YDyHc;ECxHd,8BAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;AHodD;AGldE;EACE,aAAA;EACA,8BAAA;EAEA,oBAAA;AHmdJ;AGhdI;EACE,eAAA;EACE,iBAAA;AHkdR;AGhdQ;EACE,YD6HG;EC5HH,YD6HI;AFqVd;AG/cI;EAII,iBAAA;AH8cR;AG7cQ;EAEI,YAAA;AH8cZ;AG7cY;EACE,gCAAA;EACA,yBAAA;AH+cd;AG7cY;EACE,YAAA;AH+cd;;ADxfA;EACI,2BAAA,EAAA,MAAA;EACA,0BAAA,EAAA,MAAA;EACA,8BAAA,EAAA,MAAA;AC2fJ;;ADvfA;EACI,SAAA;AC0fJ;;ADtfA;;;;;;;;;;;;;EAaI,cAAA;ACyfJ;;ADpfA;;;;EAII,qBAAA,EAAA,MAAA;EACA,wBAAA,EAAA,MAAA;ACufJ;;ADnfA;EACI,aAAA;EACA,SAAA;ACsfJ;;ADjfA;;EAEI,aAAA;ACofJ;;ADhfA;EACI,6BAAA;ACmfJ;;AD9eA;;EAEI,UAAA;ACifJ;;AD5eA;EACI,yBAAA;AC+eJ;;AD3eA;;EAEI,iBAAA;AC8eJ;;ADzeA;EACI,kBAAA;AC4eJ;;ADveA;EACI,cAAA;EACA,gBAAA;AC0eJ;;ADteA;EACI,gBAAA;EACA,WAAA;ACyeJ;;ADpeA;EACI,cAAA;ACueJ;;ADleA;;EAEI,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;ACqeJ;;ADleA;EACI,WAAA;ACqeJ;;ADleA;EACI,eAAA;ACqeJ;;AD7dA;EACI,SAAA;ACgeJ;;AD1dA;EACI,gBAAA;AC6dJ;;ADtdA;EACI,gBAAA;ACydJ;;ADndA;EAEI,uBAAA;EACA,SAAA;ACsdJ;;ADndA;;EAAA;AAIA;EACI,cAAA;ACqdJ;;ADldA;;EAAA;AAIA;;;;EAII,2BAAA;EACA,cAAA;ACodJ;;ADhdA;;;;;EAKI,cAAA,EAAA,MAAA;EACA,aAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;ACmdJ;;ADhdA;;EAAA;AAIA;EACI,iBAAA;ACkdJ;;AD/cA;;;;;EAAA;AAOA;;EAEI,oBAAA;ACidJ;;AD9cA;;;;;;EAAA;AAQA;;;;EAII,0BAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;ACgdJ;;AD7cA;;EAAA;AAIA;;EAEI,eAAA;AC+cJ;;AD5cA;;EAAA;AAIA;;EAEI,SAAA;EACA,UAAA;AC8cJ;;AD3cA;;;EAAA;AAKA;EACI,mBAAA;AC6cJ;;AD1cA;;;;;;EAAA;AAQA;;EAEI,sBAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;AC4cJ;;ADzcA;;;;EAAA;AAMA;;EAEI,YAAA;AC2cJ;;ADxcA;;;;EAAA;AAMA;EACI,6BAAA,EAAA,MAAA,EAEA,MAAA;EACA,uBAAA;AC0cJ;;ADvcA;;;;EAAA;AAMA;;EAEI,wBAAA;ACycJ;;ADtcA;;EAAA;AAIA;EACI,yBAAA;EACA,aAAA;EACA,8BAAA;ACwcJ;;ADrcA;;;EAAA;AAKA;EACI,SAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;ACucJ;;ADpcA;;EAAA;AAIA;EACI,cAAA;ACscJ;;ADncA;;;EAAA;AAKA;EACI,iBAAA;ACqcJ;;ADlcA;+EAAA;AAGA;;EAAA;AAIA;EACI,yBAAA;EACA,iBAAA;ACmcJ;;ADhcA;;EAEI,UAAA;ACmcJ;;AC/xBA;EACI,kCAAA;EACA,4CAAA;EACA,4SAAA;EAUA,mBAAA;EACA,kBAAA;ADyxBJ;ACtxBE;EACE,gCAAA;EACA,4CAAA;EACA,8SAAA;EAUA,mBAAA;EACA,kBAAA;AD+wBJ;AC3wBE;EACE,mCAAA;EACA,gEAAA;EAEA,mBAAA;EAEA,kBAAA;AD2wBJ;ACxwBE;EACE,+BAAA;EACA,6CAAA;EACA,iTAAA;EAUA,mBAAA;EACA,kBAAA;ADiwBJ;AEjxBA,iCAAA;AAIA,iCAAA;AASA,iCAAA;AAWA,iCAAA;AAQA,iCAAA;AAUA,iCAAA;AASA,iCAAA;AAQA,iCAAA;AAQA,iCAAA;AAOA,iCAAA;AAoDA;EACE,2BAAA;AF+pBF;;AE3pBA;EACE,gBAlDc;EAmDd,iBAnDc;AFitBhB;;AE5pBA;EAEE,kBAAA;AF8pBF;;AE3pBA;EACE,2BAAA;EACA,eAAA;EACA,gBAAA;AF8pBF;;AE3pBA;EACE,2BAAA;EACA,gBAAA;AF8pBF;;AE5pBA;EACE,2BAAA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;AF+pBJ;;AE3pBA;EACE,2BAAA;EACA,gBAAA;EACA,eA5CyB;AF0sB3B;;AE/oBA;EAKI,iCAAA;AFkpBJ;;AEhpBA;EACI,qBAAA;EACA,aAAA;AFmpBJ;;AIt3BA;EACE,kCAAA;EACA,4CAAA;EACA,4SAAA;EAUA,mBAAA;EACA,kBAAA;AJg3BF;AK13BA;EACG,2BAAA;AL43BH;AK13BE;EACE,eHyHU;AFmwBd;AKt3BE;EACE,wBAAA;EACA,YAAA;ALw3BJ;AKt3BE;EACE,aAAA;EACA,iBH+G0B;EG9G1B,yBHGK;AFq3BT;AKv3BI;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,iBHoGS;EGnGT,YAAA;ALy3BR;AKt3BQ;EACI,UHqGW;AFmxBvB;AKv3BY;EACI,UHoGe;EGnGf,eHoImB;EGnInB,iBAAA;ALy3BhB;AKx3BgB;EAEI,iGAAA;EACJ,oCAAA;EACA,6BAAA;ALy3BhB;AKt3BY;EACI,UHyFe;EGxFf,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ALw3BhB;AKt3BY;EACI,aAAA;ALw3BhB;AKv3BgB;EACI,qBAAA;ALy3BpB;AKv3BgB;EAEI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;ALw3BpB;AKv3BoB;EACI,yBAAA;EACA,cAAA;ALy3BxB;AKp3BQ;EACI,UHiEY;AFqzBxB;AKr3BY;EACI,YHiEO;EGhEP,UH+DM;EG9DN,YAAA;ALu3BhB;AKl3BE;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,iBHwDgC;AF4zBpC;AKn3BI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBHuCS;EGtCT,YAAA;EACA,YAAA;EACA,kBAAA;ALq3BR;AKl3BQ;EACE,iBAAA;EACA,kBAAA;ALo3BV;AKl3BQ;EACI,kBAAA;EACA,UAAA;ALo3BZ;AK/2BE;EACE,kBAAA;EACA,kBAAA;EACA,yBHnFK;AFo8BT;AKh3BI;EACE,cAAA;EACA,eAAA;ALk3BN;AKj3BM;EACE,SAAA;ALm3BR;AKj3BM;EACE,yBAAA;ALm3BR;AKl3BQ;EACI,uBAAA;ALo3BZ;AKl3BQ;EACI,uBAAA;ALo3BZ;AKl3BQ;EACE,+BAAA;ALo3BV;AK92BE;EAEE,iBHLa;EGMb,4BAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;AL+2BJ;AK52BI;EACI,gBAAA;AL82BR;AK52BI;EACE,YAAA;EACA,UAAA;EACE,aAAA;EACA,qBAAA;AL82BR;AK32BA;EACI,SAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;AL62BJ;AK12BI;EAEE,qBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AL22BN;AKz2BM;EACE,SAAA;AL22BR;AKz2BM;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AL22BR;AK12BQ;EACE,YAAA;EACC,WAAA;AL42BX;AKz2BM;EACE,cAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,eAAA;AL22BR;AKz2BM;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;AL22BR;AKt2BI;EACE,aAAA;ALw2BN;AKr2BE;EACE,aAAA;ALu2BJ;AKn2BE;EACE,YH1FgB;EG2FhB,iBH/Fa;EGgGb,YAAA;ALq2BJ;AKp2BI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;ALs2BN;AK/1BA;EACE;IACE,sBAAA;ELi2BF;EK/1BA;IACI,sBAAA;ELi2BJ;AACF;AK/1BA;EAEI;IACE,qBAAA;ELg2BJ;AACF;AK71BA;EACE;IACE,iCAAA;IACA,oBAAA;EL+1BF;EK91BE;IACE,sBAAA;ELg2BJ;EK91BE;IACE,sBAAA;ELg2BJ;EK/1BI;IAEE,uBAAA;ELg2BN;AACF;AK31BA;EAGI;IACE,qBAAA;EL21BJ;AACF;;AMzmCA;EACI,aAAA,EAAA,sBAAA;EACD,eAAA,EAAA,kBAAA;EACC,WAAA,EAAA,eAAA;EACA,kBAAA,EAAA,wBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA,EAAA,eAAA;EACA,YAAA,EAAA,gBAAA;EACA,cAAA,EAAA,4BAAA;EACA,8BAAA,EAAA,mBAAA;EACA,oCAAA,EAAA,qBAAA;AN4mCJ;;AMzmCE,kBAAA;AACA;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;AN4mCJ;;AMzmCE;EACE,yBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AN4mCJ;;AMzmCE;EACE,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AN4mCJ;AM3mCI;EACE,aAAA;AN6mCN;;AM1mCE;EACE,iBAAA;EACA,aAAA;AN6mCJ;;AM1mCE,qBAAA;AACA;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AN6mCJ;;AM1mCE;;EAEE,WAAA;EACA,qBAAA;EACA,eAAA;AN6mCJ;;AC3qCA;EACI,kCAAA;EACA,4CAAA;EACA,4SAAA;EAUA,mBAAA;EACA,kBAAA;ADqqCJ;AClqCE;EACE,gCAAA;EACA,4CAAA;EACA,8SAAA;EAUA,mBAAA;EACA,kBAAA;AD2pCJ;ACvpCE;EACE,mCAAA;EACA,gEAAA;EAEA,mBAAA;EAEA,kBAAA;ADupCJ;ACppCE;EACE,+BAAA;EACA,6CAAA;EACA,iTAAA;EAUA,mBAAA;EACA,kBAAA;AD6oCJ;AA9rCA;EACE,kBAAA;EACE,iBAAA;EACA,6CAAA;EACA,kBAAA;EACA,WAAA;AAgsCJ;;AA9rCA;EACE,WAAA;AAisCF;;AA9rCA;EAEE,WEOU;EFNV,UAAA;EACA,SAAA;EACA,mCAAA;EACA,kCAAA;EAEA,uBEVQ;EFYR,8BAAA,EAAA,0BAAA;EAMA,UAAA;EAMA,WAAA;AAorCF;AA/rCE;EACE,UAAA;EACA,WAAA;AAisCJ;AA7rCE;EACE,8BAAA;EACA,mBAAA;AA+rCJ;AA3rCE;EAEE,mBEeG;EFdH,mBAAA;AA4rCJ;;AAprCA;EACE,iBAAA;AAurCF;;AArrCA;EACE,eAAA;AAwrCF;;AAtrCA;EACE,eAAA;AAyrCF;;AAvrCA;EACE,oMAAA;EACA,WAAA;AA0rCF;;AAxrCA,yBAAA;AACA;EACE,gBAAA;EACA,yBAAA;EACA,yBAAA;EAGA,mBAAA;EACA,yCAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAyrCF;AAxrCE;EACE,yBAAA;EACA,qBAAA;AA0rCJ;;AAvrCA;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,kDAAA;AA0rCJ;;AAvrCA;EACE,8BAAA;EACA,8BAAA;AA0rCF;AAzrCE;EACE,8BAAA;AA2rCJ;;AAxrCA;EACE,0BAAA;EACA,6BAAA;EACA,gBAAA;AA2rCF;;AAzrCA;EACE,cAAA;AA4rCF;;AAzrCA;EACE,UAAA;EACA,iBAAA;EACA,6BAAA;AA4rCF;;AA1rCA;EACE,aAAA;EACA,yBAAA;AA6rCF;;AA3rCA;EACE,4BAAA;AA8rCF;;AA5rCA;EACE,iBAAA;EACA,wBAAA;EACA,WAAA;EACA,gBAAA;AA+rCF;;AA7rCA;EACE,aAAA;AAgsCF;;AA9rCA;EACI,YAAA;EAkIE,kBAAA;EAOF,UAAA;EAKA,WAAA;EAKA,oBAAA;AAkjCJ;AAnsCI;EAEQ,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;AAosCZ;AAnsCY;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AAqsChB;AAnsCY;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;EAKA,cAAA;EACA,iBAAA;EACA,kBAAA;AAqsCZ;AAnsCY;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAqsCd;AAnsCY;EACE,eAAA;AAqsCd;AAnsCY;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AAqsCZ;AApsCY;EACQ,UAAA;EACA,aAAA;EACA,kBAAA;EACA,4BAAA;EACA,cAAA;AAssCpB;AArsCoB;EACI,eAAA;AAusCxB;AAlsCoB;EACI,mBAAA;AAosCxB;AA5rCoB;EACI,UAAA;EACA,aAAA;AA8rCxB;AA1rCwB;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;EACA,4GAAA;AA4rC5B;AA1rCwB;EACI,qCAAA;AA4rC5B;AAzrCoB;EACI,cAAA;EACA,eAAA;AA2rCxB;AAzrCoB;EACI,cAAA;EACA,yBAAA;EACA,cE1LjB;EF2LiB,aAAA;EACA,mBAAA;EACA,UAAA;EACA,iBAAA;AA2rCxB;AA1rCwB;EACE,yBAAA;AA4rC1B;AA1rCwB;EACE,yBAAA;AA4rC1B;AAzrCoB;EACA,eAAA;AA2rCpB;AAxrCgB;EACI,UAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AA0rCpB;AAzrCoB;EACI,cAAA;EACA,WAAA;AA2rCxB;AAzrCoB;EACI,WAAA;EACA,WAAA;AA2rCxB;AAzrCwB;EACI,WAAA;EACA,YAAA;AA2rC5B;AAlrCI;EACI,WAAA;EACA,WAAA;AAorCR;AA/qCI;EACI,mBAAA;AAirCR;AA7qCI;EACI,gBAAA;AA+qCR;AA3qCI;EACI,gBAAA;AA6qCR;;AAzqCA;EACE,eAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;AA4qCF;AA3qCE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AA6qCJ;;AAzqCA;EACE,gBAAA;AA4qCF;;AA1qCA;EACE,iBAAA;AA6qCF;;AA3qCA;EACE,6BAAA;AA8qCF;;AA5qCA;EACE,aAAA;AA+qCF;;AA5qCA;EACE,qBAAA;AA+qCF;;AA5qCA;EACE,UAAA;AA+qCF;;AA5qCA;EACE,4CAAA;AA+qCF;;AA3qCA;EACE,yBAAA;EACA,YAAA;EACF,kBAAA;AA8qCA;;AA5qCA;EACE,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AA+qCF;;AA5qCA;EACE,iCAAA;EACA,gBAAA;EACA,kBAAA;EACD,eAAA;EAEC,WAAA;EACA,SAAA;EACA,OAAA;EACA,SAAA;EACA,YEpPU;EFqPV,yBE5We;EF6Wf,eAAA;EAEA,4BAAA;EACA,2CAAA;AA6qCF;AA3qCE;EACE,gBAAA;AA6qCJ;AA1qCE;EACE,aAAA;AA4qCJ;AA3qCI;EACE,kBAAA;EACA,qBAAA;AA6qCN;AAzqCE;EACE,yBAAA;AA2qCJ;AAxqCE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AA0qCJ;AAxqCE;EACE,aAAA;EACA,6BAAA;AA0qCJ;AAxqCE;EACE,kBAAA;EACA,mBAAA;AA0qCJ;AAzqCI;EACE,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EAGA,oCAAA;EACA,4BAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,cEzWC;EF0WD,YAAA;EACA,eAAA;EACA,aAAA;EACA,wDAAA;AAyqCN;AAxqCM;EACE,oCAAA;AA0qCR;AAtqCI;EACE,kBAAA;EACA,SAAA;EACA,UEhSQ;EFiSR,cElZK;AF0jDX;AApqCI;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAsqCN;AArqCM;EACE,YAAA;EACA,WAAA;AAuqCR;AAnqCE;EACE,aAAA;EACA,oCAAA;AAqqCJ;AAjqCE;EACE,kBAAA;EACA,sBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,mCAAA;EACA,0BAAA;EACA,uCAAA;EACA,iBErca;AFumDjB;AAjqCI;EACE,WAAA;EACA,kBAAA;AAmqCN;AAhqCI;EACE,gBAAA;EACA,cAAA;AAkqCN;AA/pCI;EACE,cE9bK;EF+bL,qBAAA;EACA,eAAA;AAiqCN;AA/pCM;EACE,0BAAA;AAiqCR;AA3pCE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;AA6pCJ;AA1pCE;EACE,eAAA;EACA,cEldO;EFmdP,+BAAA;EACA,kCAAA;EACA,0BAAA;AA4pCJ;AAxpCE;EACE,eAAA;EAEA,cEjekB;EFkelB,yCEjeqB;AF0nDzB;AAppCE;EACE,eEjWuB;EFkWvB,eAAA;AAspCJ;AAppCE;EAEE,gBAAA;AAqpCJ;AAnpCE;EACE,aAAA;EACA,gBAAA;AAqpCJ;AAnpCE;EACE,kBAAA;EACA,eE7WuB;AFkgD3B;AAlpCE;EACE,kBAAA;EACA,eElXuB;AFsgD3B;AAlpCE;EACE,kBAAA;EACA,eEtXuB;AF0gD3B;;AAhpCA;EACE,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cEpgBS;EFqgBT,+BAAA;EACA,kCAAA;EACA,0BAAA;AAmpCF;;AA/oCA;EAWE,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EAOA,iCAAA;AAkoCF;AA9pCE;EACE,cAAA;EAGA,0CAAA;EACA,qBAAA;EACA,6CAAA;EACA,wBAAA;AA8pCJ;AA/oCE;EACE,YAAA;EACA,WAAA;EACA,sBAAA;AAipCJ;AA5oCE;EAAU,UAAA;AA+oCZ;AA9oCE;EAAQ,WE5cE;AF6lDZ;;AA/oCA;EACE,aAAA;EACE,iBAAA;EACA,eAAA;AAkpCJ;AAjpCE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAmpCJ;AAjpCE;EACE,YAAA;EACA,6BAAA;EACA,wBAAA;AAmpCJ;;AA7oCA;EACE,gBAAA;EAGA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EAEA,+BAAA;AA6oCF;AA5oCE;EACE,UEhea;EFieb,UAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;AA8oCJ;AA3oCE;EACE,WAAA;AA6oCJ;;AAxoCA;EACE,qBAAA;EACA,WAAA;AA2oCF;;AAxoCA;EACE,aAAA;EACA,mBAAA;EACA,yBElnBe;EFmnBf,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AA2oCF;AA1oCE;EACE,eAAA;EACA,cEvmBe;EFwmBf,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AA4oCJ;AA1oCI;EACE,gCAAA;EACA,WE7mBqB;AFyvD3B;AAzoCI;EACE,gCAAA;EACA,WEnnBoB;AF8vD1B;AAvoCE;EACE,WAAA;EACA,WAAA;EACA,cAAA;AAyoCJ;;AApoCA;EAGE,2BAAA;EACA,iBAAA;AAqoCF;;AAjoCA;EACE,0BAAA;AAooCF;;AAloCA;EAEE,gCAAA;EAEA,kBAAA;EACA,WAAA;AAmoCF;AAloCE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AAooCJ;AAloCE;EACE,kBAAA;EACA,qBAAA;AAooCJ;AAloCE;EACE,eAAA;AAooCJ;AA9nCI;EACE,iBAAA;EAEA,sBAAA;EACA,cAAA;EACA,iBAAA;AA+nCN;AAvnCE;EACE,gBAAA;AAynCJ;AApnCE;EACE,WAAA;AAsnCJ;AAlnCE;EAIE,qBAAA;EACA,mBE5kBe;EF6kBf,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AAinCJ;AA9mCE;EACE,WAAA;AAgnCJ;AA9mCE;EACE,mBAAA;AAgnCJ;AA5mCE;EACE,sBAAA;EAGA,gBAAA;EAEA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AA2mCJ;AA1mCI;EACE,kBAAA;AA4mCN;AAvmCE;EACE,iBAAA;EACA,gBAAA;AAymCJ;AAtmCE;EAGE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;AAsmCJ;AAnmCE;EACE,eAAA;AAqmCJ;AAlmCE;EACE,aAAA;EACA,6BAAA;EACA,8BAAA;AAomCJ;AAjmCE;EACE,cAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;AAmmCJ;AAlmCI;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAomCN;AAnmCM;EACE,mBAAA;AAqmCR;AAjmCI;EACE,iBAAA;EAEA,gCAAA;EACA,sBAAA;EACA,yBAAA;AAkmCN;AA/lCI;EACE,aAAA;EACA,gBAAA;AAimCN;AA5lCI;EACE,6BAAA;EACA,YAAA;AA8lCN;AA5lCI;EACE,uBAAA;AA8lCN;AA3lCI;EACE,uBAAA;AA6lCN;AA1lCE;EACE,kBAAA;AA4lCJ;AA1lCI;EACE,WAAA;AA4lCN;AA1lCI;EACE,UAAA;AA4lCN;AAvlCE;EACE,iBAAA;AAylCJ;AAtlCE;EACE,iBAAA;AAwlCJ;AArlCI;EACA,gBAAA;EACA,aAAA;AAulCJ;AArlCE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAulCJ;AArlCI;EACE,eAAA;EACA,iBAAA;AAulCN;AAnlCE;EACE,eAAA;AAqlCJ;AAllCE;EACE,YAAA;EACA,kBAAA;AAolCJ;AA/kCE;EACE,6BAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAilCJ;AA7kCE;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBEj3Bc;EFk3Bd,gBAAA;AA+kCJ;AA7kCI;EACE,yBEp3Ba;AFm8DnB;AA5kCI;EACE,yBEv3Ba;AFq8DnB;AAvkCE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kEAAA;AAykCJ;;AArkCA;EACE,WAAA;AAwkCF;;AAnkCE;EACE,WAAA;AAskCJ;AAnkCE;EACE,yBE95BM;EFi6BN,SAAA;EACA,UE/xBa;EFiyBb,YAAA;EACA,YAAA;EAEA,sBAAA;AAikCJ;AA7jCI;EAAM,SAAA;AAgkCV;AA9jCI;EACE,WAAA;EACA,qBAAA;EACA,8BAAA;AAgkCN;AA5jCE;EAEE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;AA6jCJ;AAzjCI;EACE,yBEh8Be;EFi8Bf,iBAAA;EACA,WAAA;AA2jCN;AAxjCE;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;AA0jCJ;AAzjCI;EACE,sBAAA;AA2jCN;AAzjCI;EACE,sBAAA;EACA,YAAA;AA2jCN;AAvjCE;EACE,mBAAA;EACA,kBAAA;AAyjCJ;AAvjCI;EACE,2BAAA;EACA,4BAAA;AAyjCN;AAtjCE;EACE,mBAAA;EAEA,kBAAA;EACA,iDAAA;AAujCJ;AAtjCI;EACE,2BAAA;AAwjCN;AArjCE;EACE,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;EACA,4BAAA;AAujCJ;AAtjCI;EACE,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAwjCN;AAljCE;EACE,4BAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,iDAAA;AAojCJ;AAhjCI;EACE,cAAA;AAkjCN;AAhjCI;EACE,cAAA;AAkjCN;AA9iCM;EACE,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;AAgjCR;AA7iCI;EACE,8BAAA;EACA,2BAAA;AA+iCN;;AA3iCA;EACE,cE1gCoB;AFwjEtB;;AA3iCA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EAGA,oBAAA;EACA,0BAAA;EACA,gBAAA;EACA,qBAAA;AA4iCF;;AA1iCA;EACE,yBAAA;EACA,qBAAA;AA6iCF;;AAziCA;EAIE;IAEE,gBAAA;IACA,gBAAA;EAwiCF;AACF;AAriCA;EAEE;IACE,YAAA;EAsiCF;EApiCE;IACE,OAAA;EAsiCJ;EAliCA;IACE,cAAA;EAoiCF;EAjiCA;IACE,cAAA;EAmiCF;EAhiCA;IACE,kBAAA;IACA,qBAAA;EAkiCF;EA/hCA;IACC,sBAAA;IACC,0BAAA;EAiiCF;EA/hCA;IAEE,sBAAA;EAgiCF;AACF;AA7hCA;EACE;IACE,aAAA;EA+hCF;EA5hCA;IACE,eAAA;EA8hCF;EA3hCA;IACE,cAAA;EA6hCF;EA1hCA;IACE,aAAA;EA4hCF;EA1hCA;IACE,sBAAA;IACA,0BAAA;EA4hCF;EAzhCA;IACE,WAAA;IACA,WAAA;EA2hCF;EAxhCA;IACE,gBEl/BW;EF4gEb;EAxhCA;IAEE,sBAAA;EAyhCF;AACF;AAthCA;EACE,cAAA;AAwhCF;;AAthCA;EACE,cAAA;AAyhCF;;AAthCA;EACE,gBAAA;AAyhCF;;AAnhCA;EACI,aAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AAshCJ;;AAnhCA;EACE,YAAA;AAshCF;;AAnhCA;EACE,WAAA;AAshCF;;AAnhCA;EACE,WAAA;AAshCF;;AAphCA;EACE,oCAAA;EAEA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AAqhCF;;AAlhCA;EAEE,2BAAA;EAEE,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,6BAAA;AAmhCJ;;AAjhCA;EAEE,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAmhCF;;AA9gCA;EACE,kBAAA;AAihCF;AAhhCE;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;AAkhCJ;;AA9gCA;EACE,yBAAA;AAihCF;;AA/gCA;EAEE,yBEhqCI;EFiqCJ,yBAAA;EACA,YAAA;EAEA,cEzqCK;EF4qCL,mBAAA;EACA,gBAAA;AA8gCF;AAzgCE;EACE,YAAA;EACA,aAAA;EAGA,iBEnnCa;AF4nEjB;AArgCE;EAEE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;AAsgCJ;AArgCI;EACE,kBAAA;AAugCN;AAtgCM;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;AAwgCR;AApgCI;EACE,eAAA;AAsgCN;AApgCI;EACE,cAAA;AAsgCN;AAngCI;EACE,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;AAqgCN;AAlgCI;EACE,YAAA;EACA,mBAAA;EACA,0CAAA;EACA,uBAAA;AAogCN;AAjgCI;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAmgCN;AAhgCI;EACE,YAAA;EACA,6BAAA;EACA,aAAA;AAkgCN;AA//BI;EACE,cAAA;AAigCN;AA9/BI;EACE,aAAA;AAggCN;AA7/BI;EACE,eAAA;AA+/BN;AA5/BI;EACE,UAAA;EACA,cAAA;EACA,gCAAA;AA8/BN;AA3/BI;EACE,UAAA;AA6/BN;AA1/BI;EACE,eAAA;EACA,cAAA;EACA,uBAAA;EACA,gCAAA;AA4/BN;AAz/BI;EACE,wBAAA;AA2/BN;AAz/BI;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EAEA,cEryCD;EFsyCC,2CAAA;AA0/BR;AAz/BQ;EAEE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AA0/BV;AAv/BI;EACE,UAAA;EACA,MAAA;EACA,kBAAA;AAy/BN;;AAl/BA;EACE,kBAAA;AAq/BF;;AA/+BA;EACE,kBAAA;EACA,gBAAA;EACE,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAk/BJ;;AA/+BA;EACE,yBAAA;AAk/BF;;AAh/BA;EACE,yBAAA;AAm/BF;;AAh/BA;EACE,yBAAA;AAm/BF;;AAj/BA;EACE,yBAAA;AAo/BF;;AAj/BA;EACE,yBAAA;AAo/BF;;AAl/BA;EACE,qBAAA;AAq/BF;;AAl/BA;EACE,UAAA;EACA,YAAA;EACE,gBAAA;AAq/BJ;;AAn/BA;EACE,qBAAA;EACE,mBAAA;EACA,2BAAA;EACA,uBAAA;AAs/BJ;;AAp/BA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,6CAAA;EACA,kBAAA;EACA,WAAA;AAu/BF;;AAr/BA;EACI;IACI,wBAAA;EAw/BN;EAr/BE;IACI,wBAAA;EAu/BN;AACF","sourcesContent":["\n\nhtml {\n    font-family: PoppinsRegular; /* 1 */\n    -ms-text-size-adjust: 100%; /* 2 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n\nbody {\n    margin: 0;\n}\n\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n    display: block;\n}\n\n\n\naudio,\ncanvas,\nprogress,\nvideo {\n    display: inline-block; /* 1 */\n    vertical-align: baseline; /* 2 */\n}\n\n\naudio:not([controls]) {\n    display: none;\n    height: 0;\n}\n\n\n\n[hidden],\ntemplate {\n    display: none;\n}\n\n\na {\n    background-color: transparent;\n}\n\n\n\na:active,\na:hover {\n    outline: 0;\n}\n\n\n\nabbr[title] {\n    border-bottom: 1px dotted;\n}\n\n\nb,\nstrong {\n    font-weight: bold;\n}\n\n\n\ndfn {\n    font-style: italic;\n}\n\n\n\nh1 {\n    font-size: 2em;\n    margin: 0.67em 0;\n}\n\n\nmark {\n    background: #ff0;\n    color: #000;\n}\n\n\n\nsmall {\n    font-size: 80%;\n}\n\n\n\nsub,\nsup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n}\n\nsup {\n    top: -0.5em;\n}\n\nsub {\n    bottom: -0.25em;\n}\n\n\n\n//  * Remove border when inside `a` element in IE 8/9/10.\n \n\nimg {\n    border: 0;\n}\n\n//  * Correct overflow not hidden in IE 9/10/11.\n \n\nsvg:not(:root) {\n    overflow: hidden;\n}\n\n// /* Grouping content\n\n\n\nfigure {\n    margin: 1em 40px;\n}\n\n\n//  * Address differences between Firefox and other browsers.\n\nhr {\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n    height: 0;\n}\n\n/**\n * Contain overflow in all browsers.\n */\n\npre {\n    overflow: auto;\n}\n\n/**\n * Address odd `em`-unit font size rendering in all browsers.\n */\n\ncode,\nkbd,\npre,\nsamp {\n    font-family: PoppinsRegular;\n    font-size: 1em;\n}\n\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n    color: inherit; /* 1 */\n    font: inherit; /* 2 */\n    margin: 0; /* 3 */\n}\n\n/**\n * Address `overflow` set to `hidden` in IE 8/9/10/11.\n */\n\nbutton {\n    overflow: visible;\n}\n\n/**\n * Address inconsistent `text-transform` inheritance for `button` and `select`.\n * All other form control elements do not inherit `text-transform` values.\n * Correct `button` style inheritance in Firefox, IE 8/9/10/11, and Opera.\n * Correct `select` style inheritance in Firefox.\n */\n\nbutton,\nselect {\n    text-transform: none;\n}\n\n/**\n * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n *    and `video` controls.\n * 2. Correct inability to style clickable `input` types in iOS.\n * 3. Improve usability and consistency of cursor style between image-type\n *    `input` and others.\n */\n\nbutton,\nhtml input[type=\"button\"], /* 1 */\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n    -webkit-appearance: button; /* 2 */\n    cursor: pointer; /* 3 */\n}\n\n/**\n * Re-set default cursor for disabled elements.\n */\n\nbutton[disabled],\nhtml input[disabled] {\n    cursor: default;\n}\n\n/**\n * Remove inner padding and border in Firefox 4+.\n */\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n}\n\n/**\n * Address Firefox 4+ setting `line-height` on `input` using `!important` in\n * the UA stylesheet.\n */\n\ninput {\n    line-height: normal;\n}\n\n/**\n * It's recommended that you don't attempt to style these elements.\n * Firefox's implementation doesn't respect box-sizing, padding, or width.\n *\n * 1. Address box sizing set to `content-box` in IE 8/9/10.\n * 2. Remove excess padding in IE 8/9/10.\n */\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n    box-sizing: border-box; /* 1 */\n    padding: 0; /* 2 */\n}\n\n/**\n * Fix the cursor style for Chrome's increment/decrement buttons. For certain\n * `font-size` values of the `input`, it causes the cursor style of the\n * decrement button to change from `default` to `text`.\n */\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n    height: auto;\n}\n\n/**\n * 1. Address `appearance` set to `searchfield` in Safari and Chrome.\n * 2. Address `box-sizing` set to `border-box` in Safari and Chrome\n *    (include `-moz` to future-proof).\n */\n\ninput[type=\"search\"] {\n    -webkit-appearance: textfield; /* 1 */\n    -moz-box-sizing: content-box;\n    -webkit-box-sizing: content-box; /* 2 */\n    box-sizing: content-box;\n}\n\n/**\n * Remove inner padding and search cancel button in Safari and Chrome on OS X.\n * Safari (but not Chrome) clips the cancel button when the search input has\n * padding (and `textfield` appearance).\n */\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n    -webkit-appearance: none;\n}\n\n/**\n * Define consistent border, margin, and padding.\n */\n\nfieldset {\n    border: 1px solid #c0c0c0;\n    margin: 0 2px;\n    padding: 0.35em 0.625em 0.75em;\n}\n\n/**\n * 1. Correct `color` not being inherited in IE 8/9/10/11.\n * 2. Remove padding so people aren't caught out if they zero out fieldsets.\n */\n\nlegend {\n    border: 0; /* 1 */\n    padding: 0; /* 2 */\n}\n\n/**\n * Remove default vertical scrollbar in IE 8/9/10/11.\n */\n\ntextarea {\n    overflow: auto;\n}\n\n/**\n * Don't inherit the `font-weight` (applied by a rule above).\n * NOTE: the default cannot safely be changed in Chrome and Safari on OS X.\n */\n\noptgroup {\n    font-weight: bold;\n}\n\n/* Tables\n   ========================================================================== */\n\n/**\n * Remove most spacing between table cells.\n */\n\ntable {\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n\ntd,\nth {\n    padding: 0;\n}\n","@charset \"utf-8\";\n@import 'normalize';\n@import 'variables';\n@import 'navbar';\n@import 'home';\n@import 'modal';\n@import 'font';\n\n\n#codeblock-active{\n  margin-left: -90px;\n    padding: 5px 12px;\n    background-color: rgba(0, 0, 0, 0.8745098039);\n    border-radius: 4px;\n    color: #fff;\n}\n#active-requestBody{\n  color: grey\n}\n\nhtml, body {\n  // font-family: $proxima_nova;\n  color: $main-text;\n  padding: 0;\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  @extend %default-font;\n  background-color: $main-bg;\n  // height: 100%;\n  -webkit-text-size-adjust: none; /* Never autoresize text */\n  ::-webkit-scrollbar {\n    width: 2px;\n    height: 2px;\n  }\n  \n  /* Track */\n  ::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px grey; \n    border-radius: 10px;\n  }\n   \n  /* Handle */\n  ::-webkit-scrollbar-thumb {\n    //background: #4035de; \n    background: $N200; \n    border-radius: 10px;\n  }\n  \n  // /* Handle on hover */\n  // ::-webkit-scrollbar-thumb:hover {\n  //   background: #b30000; \n  // }\n}\n.margin-12{\n  margin-left: 12px;\n}\n.subText{\n  font-size: 16px;;\n}\n.font-18{\n  font-size: 18px;\n}\n.navBottom{\n  background-image: linear-gradient(270deg, #FF8045 6.35%, #F49666 9.54%, #E6B18F 15.9%, #DBC8B2 21.2%, #D2DACC 26.5%, #CCE6DF 32.86%, #C8EEEA 39.22%, #C7F0EE 45.58%, #CDC4F5 72.09%, #FFBD45 97.53%);\n  height: 5px;\n}\n/* CSS for tryout button*/\n.tryOut-btn {\n  appearance: none;\n  background-color: #4543d9;\n  border: 2px solid #4543d9;\n  // background-color: $P400;\n  // border: 2px solid $P400;\n  border-radius: 30px;\n  box-shadow: rgba(27, 31, 35, .1) 0 1px 0;\n  box-sizing: border-box;\n  color: #fff;\n  cursor: pointer;\n  display: inline-block;\n  font-family: PoppinsRegular;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  padding: 6px 16px;\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  vertical-align: middle;\n  white-space: nowrap;\n  margin-top: 0.2rem;\n  &:hover{\n    background-color: #7172da;\n    border-color: #7172da;\n  }\n}\n.button--loading::after {\n    content: \"\";\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n    border: 4px solid transparent;\n    border-top-color: #ffffff;\n    border-radius: 50%;\n    animation: button-loading-spinner 1s ease infinite;\n}\n\n.execute-button{\n  border-radius: 50px !important;\n  background: $P400 !important;\n  &:hover{\n    background: $P300 !important;\n  }\n}\n.entity-name{\n  display: inline !important;\n  padding-left: 23px !important;\n  font-weight: 600;\n}\n.green{\n  color: #0d904f;\n\n}\n.tryout-code-line{\n  width: 98%;\n  overflow: visible;\n  border: 2px solid transparent;\n}\n.tryout-code-line:focus-visible{\n  outline: none;\n  border: 2px solid $N75;\n}\n.header1-description{\n  margin-right: 0px !important;\n}\n.tryout-modal{\n  max-width: 1152px;\n  width: calc(100% - 48px);\n  height: 82%;\n  margin-top: 33px;\n}\n.tryout-input-section{\n  display: none;\n}\n.tryout-container{\n    height: 100%;\n    \n    .tryout-content{\n\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n            background-color: #f1f3f4;\n            .heading{\n                font-size: 18px;\n                color: #212121;\n                font-weight: 600;\n            }\n            .tryout-header-container{\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            border-bottom: 2px solid #d7d7d7;\n            -webkit-box-flex: 0;\n            -webkit-flex: 0 0 48px;\n            -moz-box-flex: 0;\n            -ms-flex: 0 0 48px;\n            flex: 0 0 48px;\n            padding-top: 12px;\n            padding-left: 20px;\n            }\n            .tryout-title{\n              display: flex;\n              justify-content: center;\n              align-items: center;\n              gap: 59rem;\n            }\n            .close-icon{\n              cursor: pointer;\n            }\n            .tryout-body-container{\n            display: flex;\n            height: 100%;\n            width: 100%;\n            overflow: auto;\n            .tryout-parameter-container{\n                    width: 38%;\n                    padding: 16px;\n                    padding-left: 20px;\n                    border-right: 1px solid gray;\n                    overflow: auto;\n                    .heading{\n                        font-size: 16px;\n                        // margin-bottom: 8px;\n                        // margin-top: 20px;\n                    }\n\n                    .parameters{\n                        margin-bottom: 12px;\n                    }\n                    .required-parameter{\n                    \n                 \n                    }\n                    .tryout-parameter-body{\n            \n                    .tryout-parameter-body-text{\n                        width: 90%;\n                        height: 200px;\n                    }\n                    }\n                    .tryout-parameter-action{\n                        button{\n                            width: 91px;\n                            height: 36px;\n                            color: #fff;\n                            border-radius: 4px;\n                            background-color: #039be5;\n                            outline: none;\n                            border: none;\n                            overflow: visible;\n                            transform: translate3d(0, 0, 0);\n                            transition: background 400ms cubic-bezier(0.25, 0.8, 0.25, 1),box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);\n                        }\n                        button[disabled]{\n                            background-color: rgba(0,0,0,.12);\n                        }\n                    }\n                    label {\n                        display:block;\n                        font-size: 16px;\n                    }\n                    input{\n                        display:block;\n                        border: 2px solid $N75;\n                        color: $N500;\n                        outline: none;\n                        border-radius: 10px;\n                        width: 90%;\n                        padding: 7px 10px;\n                        &:active{\n                          border: 2px solid $B200;\n                        }\n                        &:focus{\n                          border: 2px solid $B200;\n                        }\n                    }\n                    span{\n                    cursor: pointer;\n                    }\n                }\n                .tryout-code-samples-container{\n                    width: 60%;\n                    padding: 20px 10px;\n                    overflow: auto;\n                    background-color: #fff;\n                    position: relative;\n                    .curl-code-container{ \n                        overflow: auto;\n                        height: 40%;\n                    }\n                    .tryout-code-samples-response{\n                        width:100%;\n                        height: 60%;\n                        \n                        .response-textarea{\n                            width: 100%;\n                            height: 100%\n                        }\n                    }\n                }\n\n            }\n            \n        }\n      /* width , height*/\n    ::-webkit-scrollbar {\n        width: 10px;\n        height: 7px;\n\n    }\n    \n    /* Track */\n    ::-webkit-scrollbar-track {\n        background: #f1f1f1; \n    }\n    \n    /* Handle */\n    ::-webkit-scrollbar-thumb {\n        background: #888; \n    }\n    \n    /* Handle on hover */\n    ::-webkit-scrollbar-thumb:hover {\n        background: #555; \n    }\n}\n\n.app-loader-cntr {\n  position: fixed;\n  right: 0;\n  top: 50%;\n  left: 50%;\n  bottom: 0;\n  z-index: 9999;\n  img {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    height: 40px;\n  }\n}\n\n.margin-10{\n  margin: 10px 0px;\n}\n.bold{\n  font-weight: bold;\n}\n.extra-padding{\n  padding-top: 120px !important;\n}\n.h0{\n  display: none;\n}\n\n.side-menu-layout {\n  width: 20% !important;\n}\n\n.side-wrapper::-webkit-scrollbar {\n  width: 4px;\n}\n \n.side-wrapper::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  \n}\n \n.side-wrapper::-webkit-scrollbar-thumb {\n  background-color: #4035de;\n  opacity: 0.4;\nborder-radius: 2px;\n}\n#toc > ul > li > a > span {\n  float: right;\n  background-color: #2484FF;\n  border-radius: 40px;\n  width: 20px;\n}\n\n.side-wrapper {\n  transition: left 0.3s ease-in-out;\n  overflow-y: auto;\n  overflow-x: hidden;\n position: fixed;\n  // padding: 32px 23px 0 44px;\n  z-index: 30;\n  top: 80px;\n  left: 0;\n  bottom: 0;\n  width: $nav-width;\n  background-color: $sidewrapper-bg;\n  font-size: 14px;\n  // font-weight: bold;\n  border-right: 1px solid #ccc;\n  box-shadow: 1px 0px 0px rgba(0, 0, 0, 0.08);\n  // left: calc(calc(100% - #{$navbar-maxwidth})/2);\n  .api-method{\n    margin-left: 6px;\n  }\n  // language selector for mobile devices\n  .lang-selector {\n    display: none;\n    a {\n      padding-top: 0.5em;\n      padding-bottom: 0.5em;\n    }\n  }\n\n  .side-wrapper-body{\n    padding: 0 20px 32px 20px;\n  }\n\n  .search-container{\n    display: flex;\n    flex-direction: column;\n    margin-top: 10px;\n  }\n  .search-bar{\n    display: flex;\n    justify-content: space-evenly;\n  }\n  .search {\n    position: relative;\n    margin-bottom: 32px;\n    input {\n      background: white;\n      /* border-width: 0 0 1px 0; */\n      border: 2px solid $N75;\n      padding-left: 47px;\n      width: 80%;\n      border-radius: 10px;\n\n      // padding: 0px 47px;\n      /* -webkit-box-sizing: border-box; */\n      /* box-sizing: border-box; */\n      margin: 0px;\n      /* width: auto; */\n      /* outline: none; */\n      color: $N500;\n      height: 40px;\n      font-size:16px;\n      outline: none;\n      /* border-radius: 0;/* ios has a default border radius */\n      &:active{\n        border: 2px solid $B200 !important;\n      }\n    }\n\n    &:before {\n      position: absolute;\n      top: 17px;\n      left: $nav-padding;\n      color: $nav-text;\n      // @extend %icon-search;\n    }\n\n    .search-icon{\n      position: absolute;\n      top: 11px;\n      left: 15px; \n      width: 19px;\n      height: 19px;\n      z-index: 1;\n      img{\n        height: 100%;\n        width: 100%;\n      }\n    }\n  }\n  #input-search:focus-visible{\n    outline: none;\n    border: 2px solid $B200 !important;\n    \n  } \n \n  .search-results {\n    margin-top: 1.2rem;\n    box-sizing: border-box;\n    // height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    transition-property: height, margin;\n    transition-duration: 180ms;\n    transition-timing-function: ease-in-out;\n    background: $nav-subitem-bg;\n    &.visible {\n      height: 30%;\n      margin-bottom: 1em;\n    }\n\n    li {\n      margin: 1em $nav-padding;\n      line-height: 1;\n    }\n\n    a {\n      color: $nav-text;\n      text-decoration: none;\n      cursor: pointer;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n\n\n  ul, li {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    line-height: 28px;\n  }\n\n  li {\n    cursor: pointer;\n    color: $nav-text;\n    transition-property: background;\n    transition-timing-function: linear;\n    transition-duration: 200ms;\n  }\n\n  // This is the currently selected ToC entry\n  .toc-link.active {\n    cursor: pointer;\n    \n    color: $sidebar-active-color;\n    background-color: $sidebar-active-bg-color;\n  }\n\n \n  \n  .toc-h1{\n    font-size: $sidewrapper-header1-size;\n    cursor: pointer;\n  }\n  .toc-list-h2 {\n    //display: none;\n    font-weight: 400;\n  }\n  .toc-list-h3 {\n    display: none;\n    font-weight: 400;\n  }\n  .toc-h2 {\n    padding-left: $nav-padding + $nav-indent+10px;\n    font-size: $sidewrapper-header2-size;\n  } \n  \n  .toc-h3 {\n    padding-left: $nav-padding + $nav-padding + $nav-indent;\n    font-size: $sidewrapper-header2-size;\n  } \n  .toc-h4 {\n    padding-left: $nav-padding + $nav-padding + $nav-indent+10px;\n    font-size: $sidewrapper-header2-size;\n  }\n}\n\n.toc-link, .toc-footer li {\n  word-break: break-all;\n  padding: 0 $nav-padding 0 $nav-padding;\n  display: flex;\n  white-space: pre-wrap;\n  text-decoration: none;\n  overflow-wrap: break-word;\n  color: $nav-text;\n  transition-property: background;\n  transition-timing-function: linear;\n  transition-duration: 130ms;\n}\n\n// button to show navigation on mobile devices\n#nav-button {\n  span {\n    display: block;\n    // $side-pad: $main-padding / 2 - 8px;\n    // padding: $side-pad $side-pad $side-pad;\n    background-color: rgba($main-bg, 0.7);\n    transform-origin: 0 0;\n    transform: rotate(-90deg) translate(-100%, 0);\n    border-radius: 0 0 0 5px;\n  }\n  // padding: 0 1.5em 5em 0; // increase touch size area\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10001;\n  color: #000;\n  text-decoration: none;\n  font-weight: bold;\n  opacity: 0.7;\n  line-height: 16px;\n  margin-top: 23px;\n  margin-left: 10px;\n  img {\n    height: 25px;\n    width: 25px;\n    vertical-align: bottom;\n  }\n\n  transition: left 0.3s ease-in-out;\n\n  &:hover { opacity: 1; }\n  &.open {left: $nav-width}\n}\n.upload-button{\n  display: flex;\n    line-height: 24px;\n    cursor: pointer;\n  img{\n    width: 13px;\n    height: 13px;\n    margin-top: 4px;\n    margin-right: 6px;\n  }\n  .button{\n    color: white;\n    background-color: transparent;\n    margin: 0px 0px 0px -4px;\n  }\n}\n\n// PAGE LAYOUT AND CODE SAMPLE BACKGROUND\n\n.page-wrapper {\n  margin-left: 20%;\n  // margin-left: calc(calc(calc(100% - 1264px)/2) + 3.5%);\n  // margin-right: calc(calc(100% - 1264px)/2);\n  margin-right: 3.2%;\n  position: relative;\n  z-index: 10;\n  background-color: white;\n  min-height: 100%;\n  padding-bottom: 1px;\n  top: 58px;\n  //overflow: auto;\n  max-height: calc(100vh - 134px);\n  .dark-box {\n    width: $examples-width;\n    right: 7px;\n    top: -9px;\n    bottom: 0;\n    float: right;\n  }\n\n  .lang-selector {\n    z-index: 50;\n      // border-bottom: 5px solid $lang-select-active-bg;\n  }\n \n}\n.page-wrapper::-webkit-scrollbar {\n  width: 7px !important;\n  height: 2px;\n}\n\n.lang-selector {\n  display: flex;\n  align-items: center;\n  background-color: $lang-select-bg;\n  width: 100%;\n  height: 100%;\n  font-weight: 400;\n  overflow-x: auto;\n  a {\n    display: inline;\n    color: $lang-select-text;\n    text-decoration: none;\n    padding: 0 10px;\n    line-height: 26px;\n    outline: 0;\n\n    &:active, &:focus {\n      border-bottom: 2px solid #4035de;\n      color: $lang-select-pressed-text;\n    }\n\n    &.active {\n      border-bottom: 2px solid $N200;\n      color: $lang-select-active-text;\n    }\n  }\n\n  &:after {\n    content: '';\n    clear: both;\n    display: block;\n  }\n}\n\n// CONTENT STYLES\n.content >.main-section{\n  // padding-right: $outer-right-padding;\n  // padding: 0 40px;\n  border-top: 1px solid white;\n  padding-top: 10px;\n  // border-top: 1px solid #ccc;\n}\n// adding border except first occurrence\n.content > .main-section ~ .main-section {\n  border-top: 1px solid #ccc;\n}\n.content {\n  // fixes webkit rendering bug for some: see #538\n  -webkit-transform: translateZ(0);\n  // to place content above the dark box\n  position: relative;\n  z-index: 30;\n  &:after {\n    content: '';\n    display: block;\n    clear: both;\n  }\n  .parameter-layout{\n    margin-top: 2.5rem;\n    margin-bottom: 0.8rem;\n  }\n  .parameter-heading{\n    display: inline;\n  }\n\n  \n    \n  div{\n    &>p, &>h1, &>h2, &>h3, &>h4, &>h5, &>h6 &>ul, &>ol, &>aside, &>dl {\n      margin-right: 40%;\n      // padding: 0 $main-padding;\n      box-sizing: border-box;\n      display: block;\n      word-spacing: 1px;\n  \n      @extend %left-col;\n    }\n  }\n    \n  \n\n  &>ul, &>ol ,&>div {\n    padding-left: 5%;\n  }\n\n  // the div is the tocify hidden div for placeholding stuff\n\n  &>h1, &>h2 ,&>div{\n    clear:both;\n  \n }\n\n  div>h1 {\n    @extend %header-font;\n    // font-size: $header1-font-size;\n    // padding-top: 138px;\n    padding-bottom: 0.5em;\n    margin-bottom: $h1-margin-bottom;\n    font-weight: 500;\n    font-size: 26px;\n    line-height: 32px;\n    border-top: 1px solid #ccc;\n  }\n\n  .content:nth-child(1){\n    border: 0px;\n  }\n  h1:first-child, div:first-child + h1 {\n    border-top-width: 0;\n    // margin-top: 0;\n  }\n  \n  div>h2 {\n    word-break: break-word;\n    @extend %header-font;\n    // font-size: $header2-font-size;\n    margin-bottom: 0;\n    // padding-top: 138px;\n    padding-bottom: 1.2em;\n    line-height: 26px;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 26px;\n    padding-top: 1rem;\n    &:focus{\n      padding-top: 138px;\n    }\n  }\n\n  \n  h1 + h2, h1 + div + h2 {\n    margin-top: $h1-margin-bottom * -1;\n    border-top: none;\n  }\n\n  h3, h4, h5, h6 {\n    @extend %header-font;\n    // font-size: 20px;\n    font-weight: 500;\n    font-size: 22px;\n    line-height: 20px;\n    margin-top: 2.5em;\n    margin-bottom: 0.8em;\n    color: #313131;\n  }\n\n  h4, h5, h6 {\n    font-size: 12px;\n  }\n\n  hr {\n    margin: 2em 0;\n    border-top: 2px solid $examples-bg;\n    border-bottom: 2px solid $main-bg;\n  }\n\n  div>table {\n    display: table;\n    table-layout: fixed; \n    overflow: auto;\n    width: 50%;\n    margin-bottom: 1em;\n    th,td {\n      text-align: left;\n      vertical-align: top;\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 22px;\n      color: #000000;\n      code {\n        white-space: nowrap;\n      }\n    }\n\n    th {\n      padding: 5px 10px;\n      // border-bottom: 1px solid #ccc;\n      border-bottom: 1px solid $N75;\n      vertical-align: bottom;\n      background-color: #F7FAFB;\n    }\n\n    td {\n      padding: 10px;\n      max-width: 325px;\n    }\n\n   \n   \n    tr {\n      border-bottom: 1px solid #ccc;\n      height: 48px;\n    }\n    tr:nth-child(odd)>td {\n      background-color: lighten($main-bg,4.2%);\n    }\n\n    tr:nth-child(even)>td {\n      background-color: lighten($main-bg,2.4%);\n    }\n  }\n  table.properties{\n    table-layout: auto; \n\n    th:first-child {\n      width: auto; \n    }\n    th:last-child {\n      width: 45%;\n    }\n  }\n \n\n  dt {\n    font-weight: bold;\n  }\n\n  dd {\n    margin-left: 15px;\n  }\n\n    li, dt, dd {\n    line-height: 1.6;\n    margin-top: 0;\n  }\n  p{\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 400;\n\n    code{\n      font-size: 16px;\n      line-height: 22px;\n    }\n  }\n\n  img {\n    max-width: 100%;\n  }\n\n  code {\n    padding: 3px;\n    border-radius: 3px;\n    @extend %break-words;\n    @extend %code-font;\n  }\n\n  pre>code {\n    background-color: transparent;\n    padding: 0;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    overflow: auto;\n    // color: #333;\n  }\n\n  aside {\n    padding-top: 1em;\n    padding-bottom: 1em;\n    margin-top: 1.5em;\n    margin-bottom: 1.5em;\n    background: $aside-notice-bg;\n    line-height: 1.6;\n\n    &.warning {\n      background-color: $aside-warning-bg;\n    }\n\n    &.success {\n      background-color: $aside-success-bg;\n    }\n  }\n  \n\n\n\n  .search-highlight {\n    padding: 2px;\n    margin: -3px;\n    border-radius: 4px;\n    border: 1px solid #F7E633;\n    background: linear-gradient(to top left, #F7E633 0%, #F1D32F 100%);\n  }\n}\n\n.codeBlock{\n  color: #fff;\n}\n\n\n.content {\n  &>div.highlight {\n    clear:none;\n  }\n\n  pre, blockquote {\n    background-color: $code-bg;\n    // color: #fff;\n\n    margin: 0;\n    width: $examples-width;\n\n    float:right;\n    clear:right;\n\n    box-sizing: border-box;\n\n    @extend %right-col;\n\n    &>p { margin: 0; }\n\n    a {\n      color: #fff;\n      text-decoration: none;\n      border-bottom: dashed 1px #ccc;\n    }   \n  }\n\n  pre {\n    @extend %code-font;\n    padding-top: 2em;\n    padding-bottom: 2em;\n    padding: 2em $main-padding;\n    margin-bottom: 16px;\n    display: flex;\n    position: relative;\n    flex-direction: column;\n  }\n\n  blockquote {\n    &>p {\n      background-color: $code-annotation-bg;\n      padding: $code-annotation-padding 2em;\n      color: #eee;\n    }\n  }\n  .method-example-part{\n    max-height: 300px;\n    overflow-y: auto;\n    float: right;\n    width: 37%;\n    clear: right;\n    pre, blockquote {\n      width: 100% !important;\n    }\n    .dark-box {\n      width: 100% !important;\n      height: 46px;\n      \n    }\n  }\n  .example-request{\n    margin-bottom: 16px;\n    border-radius: 8px;\n    // box-shadow: 0 0 0 1px #00000012;\n    pre{\n      margin-bottom: 0 !important;\n      border-radius: 0 0 10px 10px;\n    }\n  }\n  .example-request-body{\n    margin-bottom: 16px;\n\n    border-radius: 8px;\n    box-shadow: 0 0 0 1px #00000012;\n    pre{\n      margin-bottom: 0 !important;\n    }\n  }\n  .response-header{\n    letter-spacing: .01em;\n    background: #E4E8ED;\n    margin-top: 19px;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    p{\n      padding: 13px 2em;\n      margin: 0;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 20px;\n      color: #3A3A3A;\n\n      \n    }\n   \n  }\n  .example-request-response{\n    max-height: 254px !important;\n    margin-bottom: 16px;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    box-shadow: 0 0 0 1px #00000012;\n    .highlight .w{\n      // background-color: #f7fafc;\n    }\n    .highlight .nl,.p{\n      color: #697386;\n    }\n    .highlight .s2{\n      color: #09825d;\n    }\n    blockquote{\n      \n      p{\n        background: #F8FAFC !important;\n        font-weight: 400;\n        font-size: 18px;\n        line-height: 26px;\n        color: #2E2E2E;\n        border-bottom: 1px solid #DFE7EC;\n      }\n    }\n    pre{\n      background: #f7fafc !important;\n      margin-bottom: 0 !important;\n    }\n  }\n}\n.active{\n  color: $sidebar-active-color;\n  // background-color: $sidebar-active-bg-color;\n}\n.link-button{\n  display: inline-block;\n  padding: 13px 21px;\n  color: #fff;\n  background-color: #4543d9;\n  border: 2px solid #4543d9;\n  // background-color: $P400;\n  // border: 2px solid $P400;\n  border-radius: 100px;\n  transition-duration: .15s;\n  font-weight: 700;\n  text-decoration: none;\n}\n.link-button:hover{\n  background-color: #7172da;\n  border-color: #7172da;\n}\n// RESPONSIVE DESIGN\n\n@media screen and (max-width:1399px) {\n  .side-wrapper{\n    // left: 5% ;\n  }\n  .page-wrapper{\n    // margin-left: calc(5% + #{$nav-width}) ;\n    margin-left: 20%;\n    margin-right: 5%;\n  }\n}\n\n@media (max-width: $tablet-width ) {\n \n  .side-wrapper {\n    left: -$nav-width;\n\n    &.open {\n      left: 0;\n    }\n  }\n\n  .page-wrapper {\n    margin-left: 0;\n  }\n\n  #nav-button {\n    display: block;\n  }\n\n  .toc-link {\n    padding-top: 0.3em;\n    padding-bottom: 0.3em;\n    \n  }\n  .method-example-part{\n   width: 100% !important; \n    margin-left: 0% !important;\n  }\n  div>table {\n    \n    width: 100% !important;\n  }\n}\n\n@media (max-width: $phone-width) {\n  .dark-box {\n    display: none;\n  }\n\n  %left-col {\n    margin-right: 0;\n  }\n\n  .side-wrapper .lang-selector {\n    display: block;\n  }\n\n  .page-wrapper .lang-selector {\n    display: none;\n  }\n  .method-example-part{\n    width: 100% !important;\n    margin-left: 0% !important;\n  }\n\n  %right-col {\n    width: auto;\n    float: none;\n  }\n\n  %right-col + %left-col {\n    margin-top: $main-padding;\n  }\n  div>table {\n    \n    width: 100% !important;\n  }\n}\n\n.highlight .c, .highlight .cm, .highlight .c1, .highlight .cs {\n  color: #909090;\n}\n.highlight .s1{\n  color: #85d996;\n}\n\n.highlight .nt, .highlight .nl{\n  color: aliceblue;\n}\n.highlight, .highlight .w {\n  // background-color: $code-bg;\n}\n\n.copy-clipboard, .curl-copy-clipboard {\n    fill: #9DAAB6;\n    position: absolute;\n    cursor: pointer;\n    opacity: 0.4;\n    height: 18px;\n    right: 29px;\n    width: 18px;\n}\n\n.copy-clipboard, .curl-copy-clipboard:hover {\n  opacity: 0.8;\n}\n\n.container{\n  margin: 0px;\n}\n\n.content{\n  margin: 0px;\n}\n.button{\n  background-color: rgba(255, 255, 255, 1);\n  \n  border: 1px solid #4035de;\n  border-radius: 30px;\n  font-size: 16px;\n  color: #4035de;\n  \n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin: 0 4px;\n  \n}\n.resource-group{\n  @extend %sidewraper-heading-font;\n  padding: 2px 3px !important;\n    // background-color: white !important;\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    margin-bottom: 5px !important;\n}\n.resource-group .heading a {\n\n  margin: 0 0 5px 0;\n  border: 0;\n  border-radius: 0;\n  padding-right: 0px;\n  cursor: pointer;\n    // &:hover {\n    //   background-color: rgba(246, 247, 249, 1);  \n    //   }\n}\n.heading {\n  position: relative;\n  img{\n    width: 18px;\n    height: 18px;\n    top: 3px;\n    position: absolute;\n  }\n}\n\n.show {\n  display: block !important;\n}\n.sub-header-bar{\n//  background-color: $sub-header-bar-bg; \n  background-color: $N50; \n  border: 1px solid $N50;\n  height: 40px;\n  // color: $sub-header-bar-text;\n  color: $N400;\n// position: fixed;\n  // width: 80%;\n  border-radius: 10px;\n  margin-top: 10px;\n  // top: 0;\n  // width: 363px;\n  // z-index: 31;\n//  margin-top: $navbar-height;\n  .sub-header-bar-content{\n    height: 100%;\n    display: flex;\n    // padding-left: $header-content-padding-left;\n    // padding-right: $header-content-padding-right;\n    max-width: $navbar-maxwidth;\n    // margin: auto;\n    @extend %corner-padding;\n  }\n  .sub-header-bar-menu{\n    // width: 100%;\n    position: relative;\n    display: flex;\n    height: 100%;\n    align-items: center;\n    justify-content: space-between;\n    .version-tag{\n      position: relative;\n      span{\n        float: right;\n        padding-left: 7px;\n        padding-top: 3px;\n      }\n    }\n\n    .version-tag:hover{\n      cursor: pointer;\n    }\n    .version-active{\n      display: block;\n    }\n\n    body {\n      background-color: #FAC945;\n      justify-content: center;\n      display: flex;\n      height: 100vh;\n      margin-top: 150px;\n      font-size: 17px;\n      color: #4B4D54;\n      overflow: hidden;\n      font-family: PoppinsRegular;\n    }\n    \n    .dropdown {\n      width: 300px;\n      border-radius: 10px;\n      box-shadow: 0 10px 25px rgba(0,0,0,.1);\n      background-color: white;\n    }\n    \n    .dropdown-header {\n      padding: 15px;\n      cursor: pointer;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n    \n    .dropdown-body {\n      padding: 5px;\n      border-top: 1px solid #E5E8EC;\n      display: none;\n    }\n    \n    .dropdown-body.open {\n      display: block;\n    }\n    \n    .dropdown-item {\n      padding: 10px;\n    }\n    \n    .dropdown-item:hover {\n      cursor: pointer;\n    }\n    \n    .dropdown-item-dot {\n      opacity: 0;\n      color: #91A5BE;\n      transition: all .2s ease-in-out;\n    }\n    \n    .dropdown-item-dot.selected {\n      opacity: 1;\n    }\n    \n    .icon {\n      font-size: 13px;\n      color: #91A5BE;\n      transform: rotate(0deg);\n      transition: all .2s ease-in-out;\n    }\n    \n    .icon.open {\n      transform: rotate(90deg);\n    }\n    .version-tag-option{\n        display: block;\n        position: absolute;\n        min-width: 144px;\n        top: 36px;\n        display: none;\n        padding: 13px 14px;\n        background: inherit;\n        background-color: rgba(255, 255, 255, 1);\n        box-sizing: border-box;\n        border-width: 1px;\n        border-style: solid;\n        border-color: rgba(242, 242, 242, 1);\n        border-radius: 5px;\n        z-index: 99;\n        //color: #4035de;\n        color:$N600;\n        box-shadow: 0px 0px 8px rgba(0, 0 ,0 , 8%);\n        a{\n          //color: #4035de;\n          display: block;\n          position: relative;\n          cursor: pointer;\n          text-decoration: none;\n        }\n      }\n    .down-arrow{\n      right: 9px;\n      top: 0;\n      position: absolute;\n    }\n    \n\n  }\n}\n\n.arrow{\n  padding-right:5px;\n}\n\n\n\n\n.api-method{\n  border-radius: 3px;\n  padding: 0px 7px;\n    color: white;\n    display: inline-flex;\n    justify-content: center;\n    height: 18px;\n    line-height: 18px;\n    text-transform: uppercase;\n    margin-bottom: auto;\n    margin-top: auto;\n    margin-left: 5px;\n    @extend %api-method-font;\n}\n.get{\n  background-color: #0e9b71;\n}\n.options{\n  background-color: #0272d9;\n\n}\n.post{\n  background-color: #0272d9;\n}\n.put{\n  background-color: #674ead;\n\n}\n.patch{\n  background-color: #df7d03;\n}\n.delete{\n  background-color: red;\n}\n\n.sidebar-link-text{\n  width: 73%;\n  height: 30px;\n    overflow: hidden;\n}\n.sidebar-item-link{\n  display: inline-block;\n    white-space: nowrap;\n    overflow: hidden !important;\n    text-overflow: ellipsis;\n}\n#custom-tooltip {\n  display: none;\n  margin-left: -100px;\n  padding: 5px 12px;\n  background-color: #000000df;\n  border-radius: 4px;\n  color: #fff;\n}\n@keyframes button-loading-spinner {\n    from {\n        transform: rotate(0turn);\n    }\n\n    to {\n        transform: rotate(1turn);\n    }\n}\n","@font-face {\n    font-family: \"proxima_novaregular\";\n    src: url(\"../font/proxima-nova-regular/proximanova-regular-webfont.eot\");\n    src: url(\"../font/proxima-nova-regular/proximanova-regular-webfont.eot?#iefix\")\n        format(\"embedded-opentype\"),\n      url(\"../font/proxima-nova-regular/proximanova-regular-webfont.woff2\")\n        format(\"woff2\"),\n      url(\"../font/proxima-nova-regular/proximanova-regular-webfont.woff\")\n        format(\"woff\"),\n      url(\"../font/proxima-nova-regular/proximanova-regular-webfont.ttf\")\n        format(\"truetype\"),\n      url(\"../font/proxima-nova-regular/proximanova-regular-webfont.svg#proxima_novaregular\")\n        format(\"svg\");\n    font-weight: normal;\n    font-style: normal;\n  }\n  \n  @font-face {\n    font-family: \"proxima_novalight\";\n    src: url(\"../font/proxima-nova-light/proximanova-light-webfont.eot\");\n    src: url(\"../font/proxima-nova-light/proximanova-light-webfont.eot?#iefix\")\n        format(\"embedded-opentype\"),\n      url(\"../font/proxima-nova-light/proximanova-light-webfont.woff2\")\n        format(\"woff2\"),\n      url(\"../font/proxima-nova-light/proximanova-light-webfont.woff\")\n        format(\"woff\"),\n      url(\"../font/proxima-nova-light/proximanova-light-webfont.ttf\")\n        format(\"truetype\"),\n      url(\"../font/proxima-nova-light/proximanova-light-webfont.svg#proxima_novalight\")\n        format(\"svg\");\n    font-weight: normal;\n    font-style: normal;\n    \n  }\n  \n  @font-face {\n    font-family: \"proxima_novasemibold\";\n    src: url(\"../font/proxima-nova-semi-bold/ProximaNova-Semibold.otf\")\n      format(\"opentype\");\n    font-weight: normal;\n    \n    font-style: normal;\n  }\n  \n  @font-face {\n    font-family: \"proxima_novabold\";\n    src: url(\"../font/proxima-nova-bold/proximanova-bold-webfont.eot\");\n    src: url(\"../font/proxima-nova-bold/proximanova-bold-webfont.eot?#iefix\")\n        format(\"embedded-opentype\"),\n      url(\"../font/proxima-nova-bold/proximanova-bold-webfont.woff2\")\n        format(\"woff2\"),\n      url(\"../font/proxima-nova-bold/proximanova-bold-webfont.woff\")\n        format(\"woff\"),\n      url(\"../font/proxima-nova-bold/proximanova-bold-webfont.ttf\")\n        format(\"truetype\"),\n      url(\"../font/proxima-nova-bold/proximanova-bold-webfont.svg#proxima_novabold\")\n        format(\"svg\");\n    font-weight: normal;\n    font-style: normal;\n    \n  }","\n@import \"_font.scss\";\n@import url(\"../Poppins.scss\");\n\n\n// BACKGROUND COLORS\n$sidewrapper-bg: #F8F8F8 !default;\n$navbar-bg: rgba(255, 255, 255, 1) !default;\n$examples-bg: #2E3336 !default;\n$code-bg: #35393C !default;\n$code-annotation-bg: #42484C !default;\n$nav-subitem-bg: white !default;\n$nav-active-bg: #0F75D4 !default;\n$nav-active-parent-bg: #1E2224 !default; // parent links of the current section\n$lang-select-border: #000 !default;\n$lang-select-bg: #42484C !default;\n$lang-select-active-bg: #3c4257 !default; // feel free to change this to blue or something\n$lang-select-pressed-bg: #111 !default; // color of language tab bg when mouse is pressed\n$main-bg: white !default;\n$aside-notice-bg: #8fbcd4 !default;\n$aside-warning-bg: #c97a7e !default;\n$aside-success-bg: #6ac174 !default;\n$search-notice-bg: #c97a7e !default;\n$sub-header-bar-bg: #4035de !default;\n$home-bg:#f7f7f7 !default;\n$sidebar-active-color:#4035de !default;\n$sidebar-active-bg-color:rgba(#4035de, 0.09) !default;\n// TEXT COLORS\n\n$main-text: #333 !default; // main content text color\n$nav-text: #222222 !default;\n$nav-active-text: #fff !default;\n$nav-active-parent-text: #fff !default; // parent links of the current section\n$lang-select-text: #FFFFFF !default; // color of unselected language tab text\n$lang-select-active-text: #fff !default; // color of selected language tab text\n$lang-select-pressed-text: #fff !default; // color of language tab text when mouse is pressed\n$navbar-text: #4035de !default;\n$sub-header-bar-text: white !default;\n$scrollbar-background-colour-active:#4035de !default;\n$scrollbar-background-colour:#97c3ca !default;\n\n\n/* Core ----------------------- */\n$PDS_black: #000000;\n$PDS_white: #ffffff;\n\n/* Grays ---------------------- */\n$GR500: #404040;\n$GR400: #525252;\n$GR300: #a2a2a2;\n$GR200: #cccccc;\n$GR100: #ebebeb;\n$GR50: #f1f3f4;\n$GR25: #f8f9fb;\n\n/* Neutrals ------------------- */\n$N600: #43515C;\n$N500: #353b46;\n$N400: #464f5e;\n$N300: #637085;\n$N200: #8c95a8;\n$N100: #aeb5c2;\n$N75: #d1d5dc;\n$N50: #e8eaee;\n$N40: #f4f6fa;\n\n/* Primary -------------------- */\n$P500: #1d3734;\n$P400: #3c6d68;\n$P300: #5ca59b;\n$P200: #58d7c9;\n$P100: #91dfd5;\n$P75: #c1e5e2;\n$P50: #d8f4f2;\n/* Blue ----------------------- */\n$B500: #0c0b3b;\n$B400: #1c1876;\n$B300: #2927b2;\n$B200: #4d3ee0;\n$B100: #7571e0;\n$B75: #a391f2;\n$B50: #cac1f2;\n$B40: #eae8fb;\n\n/* Kobe ----------------------- */\n$K500: #491f08;\n$K400: #913d1c;\n$K300: #da5c30;\n$K200: #f6814b;\n$K100: #eba47f;\n$K75: #f0c1a8;\n$K50: #f7e1d4;\n\n/* Brown ---------------------- */\n$BR500: #4a350f;\n$BR400: #956727;\n$BR300: #e09e3e;\n$BR200: #f8ba4b;\n$BR100: #facd78;\n$BR75: #f5ddab;\n$BR50: #fbedd5;\n/* Red ------------------------ */\n$R500: #c40f24;\n$R400: #ef233c;\n$R300: #f14458;\n$R200: #f36374;\n$R100: #f9b1b9;\n$R75: #fcd9dd;\n\n/* Yellow --------------------- */\n$Y500: #ba4800;\n$Y400: #df6e38;\n$Y300: #ff8b00;\n$Y200: #ffcd92;\n$Y100: #fffae6;\n\n/* Green ---------------------- */\n$G500: #006644;\n$G400: #00875a;\n$G300: #36b37e;\n$G200: #85dbbe;\n$G100: #e6f9f3;\n\n// SIZES\n$corner-padding:2% !default;\n$nav-width: 279px !default; // width of the navbar\n$navbar-maxwidth:1264px !default;\n$navbar-height:78px !default;\n\n$home-heading:32px !default;\n$home-footer-height:98px !default;\n$home-intro-container-height: 480px !default;\n$home-intro-info-width:50% !default;\n$home-intro-info-heading-width:60% !default;\n$home-intro-image-width:50% !default;\n$home-intro-img-width:80% !default;\n$home-intro-img-height:100% !default;\n\n$home-instruction-container-height: 576px !default;\n\n$examples-width: 40% !default; // portion of the screen taken up by code examples\n$logo-margin: 0px !default; // margin below logo\n$main-padding: 28px !default; // padding to left and right of content & examples\n$nav-padding: 15px !default; // padding to left and right of navbar\n$nav-v-padding: 10px !default; // padding used vertically around search boxes and results\n$nav-indent: 10px !default; // extra padding for ToC subitems\n$code-annotation-padding: 13px !default; // padding inside code annotations\n$h1-margin-bottom: 21px !default; // padding under the largest header tags\n$tablet-width: 1024px !default; // min width before reverting to tablet size\n$phone-width: $tablet-width - $nav-width !default; // min width before reverting to mobile size\n$navbar-heading: 12px !default;\n$logo-width: 118px !default;\n$logo-height: 43px !default;\n$card-heading:20px !default;\n$outer-right-padding:40px;\n$scrollbar-width:10px !default;\n$scrollbar-height:4px !default;\n$header-content-padding-left: 18px !default;\n$header-content-padding-right: 18px !default;\n$api-method-tag-font-size: 12px !default;\n$sidewrapper-header1-size: 16px !default;\n$sidewrapper-header2-size: 16px !default;\n$header1-font-size:32px !default;\n$header2-font-size:18px !default;\n$paragraph-font-size:32px !default;\n// FONTS Size\n$home-intro-info-heading-font-size:32px !default;\n\n%default-font {\n  font-family: PoppinsRegular;\n  \n}\n\n%corner-padding{\n  padding-left: $corner-padding;\n  padding-right: $corner-padding;\n}\n%header-font {\n  @extend %default-font;\n  font-style: normal;\n}\n\n%code-font {\n  font-family: PoppinsRegular;\n  font-size: 14px;\n  line-height: 1.5;\n  \n}\n%navbar-font{\n  font-family: PoppinsRegular;\n  font-weight: 650;\n}\n%sidewraper-heading-font{\n  font-family: PoppinsRegular;\n    font-weight: 500;\n    font-style: normal;\n    font-size: 14px;\n    \n\n}\n%api-method-font{\n  font-family: PoppinsRegular;\n  font-weight: 500;\n  font-size: $api-method-tag-font-size;\n  \n\n}\n\n$proxima_nova:\"proxima_novaregular\";\n$proxima_nova_semi_bold: \"proxima_novasemibold\";\n\n$nav-footer-border-color: #666 !default;\n$search-box-border-color: #666 !default;\n\n\n\n// These settings are probably best left alone.\n\n%transition{\n  -o-transition: all ease-in-out .25s;\n    -moz-transition: all ease-in-out .25s;\n    -ms-transition: all ease-in-out .25s;\n    -webkit-transition: all ease-in-out .25s;\n    transition: all ease-in-out .25s;\n}\n%break-words {\n    word-break: break-all;\n    hyphens: auto;\n}\n\n@media (max-width: 1263px) {\n\n  $navbar-maxwidth:616px !important;\n\n}\n@media (max-width: 615px) {\n\n  $navbar-maxwidth:400px !important;\n\n}","@charset \"utf-8\";\n@import 'variables';\n.navbar-container{\n\t@extend %navbar-font;\n  position: fixed!important;\n\twidth: 100%!important;\n\theight: $navbar-height;\n\tbackground: $navbar-bg;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tz-index: 5000;\n\tcolor: $navbar-text !important;\n\n  .navbar-content{\n    display: flex;\n    justify-content: space-between;\n    @extend %corner-padding;\n    padding-bottom: 10px;\n    // max-width: $navbar-maxwidth;\n    // margin: auto;\n    .navbar-heading{\n      font-size: 12px;\n        padding-top: 17px;  \n        // margin-left: 20px;     \n        img{\n          width: $logo-width;\n          height: $logo-height;\n        }\n    }\n    .navbar-list{\n        // display: flex;\n        // width: 30%;\n        // justify-content: flex-end;\n        padding-top: 10px;\n        .navbar-list-content{\n            // width: 112px;\n            height: 40px;  \n            a{\n              text-decoration: none !important;\n              color: #4035de !important;      \n            }\n            .navbar-list-content-heading{\n              margin: auto;\n              \n          }\n        }\n      \n    }\n  }\n}\n\n\n\n\n\n\n","@font-face {\n  font-family: \"proxima_novaregular\";\n  src: url(\"../font/proxima-nova-regular/proximanova-regular-webfont.eot\");\n  src: url(\"../font/proxima-nova-regular/proximanova-regular-webfont.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../font/proxima-nova-regular/proximanova-regular-webfont.woff2\")\n      format(\"woff2\"),\n    url(\"../font/proxima-nova-regular/proximanova-regular-webfont.woff\")\n      format(\"woff\"),\n    url(\"../font/proxima-nova-regular/proximanova-regular-webfont.ttf\")\n      format(\"truetype\"),\n    url(\"../font/proxima-nova-regular/proximanova-regular-webfont.svg#proxima_novaregular\")\n      format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n  \n}\n\n%icon {\n  font-family: \"proxima_novaregular\";\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  \n}\n\n%icon-exclamation-sign {\n  @extend %icon;\n  content: \"\\e600\";\n}\n%icon-info-sign {\n  @extend %icon;\n  content: \"\\e602\";\n}\n%icon-ok-sign {\n  @extend %icon;\n  content: \"\\e606\";\n}\n%icon-search {\n  @extend %icon;\n  content: \"\\e607\";\n}\n","@charset \"utf-8\";\n@import 'normalize';\n@import 'variables';\n@import 'icon-font';\n.home {\n   margin-top: $navbar-height !important;\n    @extend %transition;\n  .heading{\n    font-size: $home-heading;\n  }\n  \n  \n  \n  \n  .postBody{\n    height:100px !important;\n    color: black;\n  }\n  .intro-container{\n    display: flex;\n    min-height: $home-intro-container-height;\n    background-color: $home-bg;\n    .intro-body{\n        display: flex;\n        height: 100%;\n        align-items: center;\n        max-width: $navbar-maxwidth;\n        margin: auto;\n        @extend %corner-padding;\n        \n        .intro-info{        \n            width: $home-intro-info-width;\n            .intro-heading{\n                width: $home-intro-info-heading-width;\n                font-size: $home-intro-info-heading-font-size;\n                line-height: 48px;\n                .company-name{\n                    // color: linear-gradient(red, yellow);\n                    background: linear-gradient(89.88deg,#ff8045 2.69%,#7bd3cf 43.19%,#ab9cee 72%,#ffbd45 99.83%);\n                -webkit-text-fill-color: transparent; \n                -webkit-background-clip: text; \n                }\n            }\n            .intro-description{\n                width: $home-intro-info-heading-width;\n                font-weight: 400;\n                font-size: 18px;\n                line-height: 26px;\n                color: #000000;\n            }\n            .intro-action{\n                display: flex;                \n                a{\n                    text-decoration: none;                \n                }\n                .button{\n                    // margin: 5px;\n                    height: 42px;\n                    line-height: 22px;\n                    font-size: 14px;\n                    padding: 0px 24px;  \n                    &:hover{\n                        background-color: #4035de;\n                        color: #ffffff;\n                    }      \n                }\n            }\n        }\n        .intro-image{\n            width: $home-intro-image-width;\n            img{\n                height: $home-intro-img-height;\n                width: $home-intro-img-width;\n                float: right;\n            }\n        }\n    }\n  }\n  .instruction-container{\n    display: flex;\n    background-color: white;\n    padding: 15px;\n    min-height: $home-instruction-container-height;\n    .instruction-body{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        max-width: $navbar-maxwidth;\n        margin: auto;\n        height:100%;\n        text-align: center;\n        @extend %corner-padding;\n        \n        .api-list{\n          padding-left: 0px;\n          padding-right: 0px;\n        }\n        .card-body{\n            text-align: center;\n            padding: 0;\n          }\n    }\n    \n  }\n  .api-container{\n    padding: 100px 0px;\n    text-align: center;\n    background-color: $home-bg; \n    .card{\n      overflow: auto;\n      cursor: pointer;\n      .card-logo{\n        fill:red;\n      }\n      &:hover{\n        background-color: #4035de;\n        .card-heading{\n            color: white !important;\n        }\n        .card-description{\n            color: white !important;\n        }\n        .card-logo{\n          filter:  brightness(0) invert(1);\n        }\n      }\n    }\n  }\n  \n  .api-list{\n    // width: 80% !important;\n    max-width: $navbar-maxwidth;\n    margin: 59px auto !important;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    @extend %corner-padding;\n   \n    .card-heading{\n        margin-top: 35px;\n    }\n    a{\n      margin: auto;\n      width: 25%;\n        height: 232px;\n        text-decoration: none;\n    }\n}   \n.card{\n    margin: 0;\n    padding: 32px 32px 32px 32px;\n    display: block;\n    position: relative;\n    text-align: left;\n    background: #ffffff;\n    box-sizing: border-box;\n    border-radius: 11px;\n    border: solid 1px transparent;\n    height: 100%;\n    @extend %transition;\n    \n    .card-body{\n\n      word-wrap: break-word;\n      width: auto;\n      bottom: 0;\n      margin: 0;\n      text-align: left;\n      height: 100%;\n      overflow: auto;\n     \n      .card-logo {\n        fill: red;\n      }\n      .card-icon-body{\n        margin: auto;\n        margin-top: 11px;\n        margin-bottom: 0px;\n        border-radius: 50%;\n        padding: 4px 6px;\n        background-color: rgba(24, 172, 180, 0.247058823529412);\n        img{\n          height: 22px;\n           width: 22px;\n        }\n      }\n      .card-heading{\n        color: #4a4a4a;\n        width: 100%;\n        margin: 0;\n        font-size: 1.5rem;\n        line-height: 36px;\n        text-shadow: none;\n        text-transform: capitalize;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        -o-text-overflow: ellipsis;\n        -ms-text-overflow: ellipsis;\n        max-width: 100%;\n      }\n      .card-description{\n        color: #272727;\n        line-height: 24px;\n        font-size: 1rem;\n        margin: 16px 0 44px 0;\n        overflow: hidden;\n        // max-height: 72px;\n        // height: 72px;\n        }\n    }\n    .card-body::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  .card::-webkit-scrollbar {\n    display: none;\n  }\n  \n  \n  .footer{\n    height: $home-footer-height;\n    max-width: $navbar-maxwidth;\n    margin: auto;\n    .footer-body{\n      display: flex;\n      align-items: center;\n      height: 100%;\n    }\n  }\n  \n  \n \n  \n@media (max-width: 1024px) {\n  .intro-heading{\n    width: 100% !important;\n  }\n  .intro-description{\n      width: 100% !important;\n  }\n}\n@media (max-width: 998px) {\n  .api-list{\n    a{\n      width: 42% !important;\n    }\n  }\n}\n@media (max-width: 768px) {\n  .intro-body{\n    flex-direction: column !important;\n    gap: 30px !important;\n    .intro-info{\n      width: 100% !important;\n    }\n    .intro-image{\n      width: 100% !important;\n      img{\n       \n        float: unset !important;\n    }\n    }\n  }\n  \n}\n@media (max-width: 484px) {\n \n  .api-list{\n    a{\n      width: 84% !important;\n    }\n  }\n}\n}",".modal {\n    display: none; /* Hidden by default */\n   position: fixed; /* Stay in place */\n    z-index: 31; /* Sit on top */\n    padding-top: 100px; /* Location of the box */\n    left: 0;\n    top: 0;\n    width: 100%; /* Full width */\n    height: 100%; /* Full height */\n    overflow: auto; /* Enable scroll if needed */\n    background-color: rgb(0,0,0); /* Fallback color */\n    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */\n  }\n  \n  /* Modal Content */\n  .modal-content {\n    background-color: #fefefe;\n    margin: auto;\n    margin-top: 9%;\n    padding: 0px;\n    border: 1px solid #888;\n    width: 80%;\n    max-width: 540px;\n  }\n\n  .modal-header{\n    background-color: #4035de;\n    /* margin-top: -14px; */\n    height: 49px;\n    padding: 1px 37px;\n    color: white;\n  }\n\n  .modal-action{\n    border-top: 1px solid gray;\n    margin-top: 10px;\n    display: flex;\n    padding: 0px 15px;\n    height: 48px;\n    align-items: center;\n    justify-content: flex-end;\n    .loading-button{\n      display: none;\n    }\n  }\n  .modal-body{\n    padding: 0px 37px;\n    height: 200px;\n  }\n  \n  /* The Close Button */\n  .close {\n    color: #aaaaaa;\n    float: right;\n    font-size: 14px;\n    font-weight: bold;\n  }\n  \n  .close:hover,\n  .close:focus {\n    color: #000;\n    text-decoration: none;\n    cursor: pointer;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
